<template>
  <el-container class="finance_table_div">
    <el-header class="header-style">
      <!-- <el-divider content-position="left">财务登记表</el-divider> -->
      <el-row style="margin: 0 0 0.2rem 0">
        <el-col :span="5">
          <el-select
            v-model="searchArr.company_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入公司字号筛选公司"
            size="mini"
            clearable
            @change="handleCompanyChange"
            :remote-method="remoteCompanyMethod"
            :loading="loading"
          >
            <el-option
              v-for="company in companies"
              :key="company.id"
              :label="company.company_name"
              :value="company.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="padding-right: 0; margin-left: 0.2rem">
          <el-select
            v-model="setField"
            multiple
            filterable
            collapse-tags
            size="mini"
            placeholder="请选择自定义显示的字段"
            :popper-append-to-body="false"
            @change="handleColChange"
          >
            <el-option
              v-for="field in fields"
              :key="field.id"
              :label="field.name"
              :value="field.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" style="padding-right: 0; margin-left: 0.2rem">
          <el-select
            v-model="selectedColumns"
            multiple
            filterable
            collapse-tags
            size="mini"
            placeholder="请选择自定义固定列"
            :popper-append-to-body="false"
            @change="handleColumnSelectionChange"
          >
            <el-option
              v-for="field in fields"
              :key="field.id"
              :label="field.name"
              :value="field.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10" class="tr" style="float: right">
          <el-tooltip
            class="item"
            effect="dark"
            content="导入服务开始时间和结束时间"
            placement="top"
          >
            <el-popover placement="bottom-start" trigger="hover">
              <el-upload
                action=""
                :headers="headers"
                ref="uploadMutiple"
                :show-file-list="false"
                :http-request="upload"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="导入服务开始时间和结束时间"
                  placement="top"
                >
                  <el-button type="warning" size="mini">导入</el-button>
                </el-tooltip>
              </el-upload>
              <el-link @click.native="showExample">查看导入说明</el-link>
              <el-button size="mini" type="success" slot="reference">导入</el-button>
            </el-popover>
          </el-tooltip>

          <el-upload
            style="display: inline-block"
            action="https://weixin.qiyehuo.com/api/admin/finance/import_service_advisor"
            :headers="headers"
            :show-file-list="false"
          >
            <el-button type="success" size="mini">导入财务人员</el-button>
          </el-upload>
          <el-tooltip class="item" effect="dark" content="导出" placement="top">
            <el-button type="success" size="mini" @click="exportFinanceLists"
              >导出</el-button
            >
          </el-tooltip>

          <el-upload
            style="display: inline-block"
            action="https://weixin.qiyehuo.com/api/admin/finance/import_leader"
            :headers="headers"
            :show-file-list="false"
          >
            <el-button type="success" size="mini">批量更新财税负责人</el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-row :span="24">
        <div class="top_hint">
          <span class="count">
            已过期：<span style="color: red; font-weight: bold">{{ header.overd }}</span
            >&nbsp;&nbsp;&nbsp; 一个月内到期：<span
              style="color: red; font-weight: bold"
              >{{ header.oneMonth }}</span
            >&nbsp;&nbsp;&nbsp; 两个月内到期：<span
              style="color: red; font-weight: bold"
              >{{ header.twoMonth }}</span
            >&nbsp;&nbsp;&nbsp; 三个月内到期：<span
              style="color: red; font-weight: bold"
              >{{ header.threeMonth }}</span
            >&nbsp;&nbsp;&nbsp;
          </span>
        </div>
      </el-row>
      <el-collapse v-model="activeOpen">
        <el-collapse-item name="1">
          <template slot="title">
            高级筛选<i class="header-icon el-icon-info"></i>
          </template>
          <el-card shadow="always" style="margin-bottom: 0.2rem">
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">财税负责人</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.leader_id"
                  placeholder="请选择财税负责人"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="2" class="options-second">理票会计</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.acc_id"
                  placeholder="请选择理票会计"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="2" class="options-second">记账报税会计</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.advisory_id"
                  placeholder="请选择记账报税会计"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
                
              </el-col>
              <el-col :span="2" class="options-second">客服会计</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.ass_id"
                  placeholder="请选择客服会计"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
                
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">开票会计</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.invoice_id"
                  placeholder="请选择开票会计"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
                
              </el-col>
              <el-col :span="2" class="options-second">所属业务</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.saler_id"
                  placeholder="请选择所属业务"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
                
              </el-col>
              <el-col :span="2" class="options-second">财务代表</el-col>
              <el-col :span="3" class="options">
                <el-input
                  v-model="searchArr.finance_user"
                  size="mini"
                  clearable
                ></el-input>
              </el-col>
              <el-col :span="2" class="options-second">法定代表</el-col>
              <el-col :span="3" class="options">
                <el-input v-model="searchArr.legal_name" size="mini" clearable></el-input>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">财税顾问</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.service_advisor_id"
                  placeholder="请选择财税顾问"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="2" class="options-second">综合会计</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.general_accounting_id"
                  placeholder="请选择综合会计"
                  :options="usersConvert"
                  size="mini"
                  :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :span="2" class="options-second">纳税人识别号</el-col>
              <el-col :span="5">
                <el-input v-model="searchArr.taxNumber" size="mini" clearable></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-checkbox v-model="serviceEvent" @change="serviceEventState"
                >服务对接情况</el-checkbox
              >
              <el-checkbox v-model="serviceThings" @change="serviceThingsState"
                >企业服务事项</el-checkbox
              >
              <el-checkbox v-model="serviceAccount" @change="serviceAccountState"
                >账号状态信息</el-checkbox
              >
            </el-row>
          </el-card>

          <el-card
            shadow="always"
            style="margin-bottom: 0.2rem"
            v-if="serviceEvent === true"
          >
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">所属区域</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  v-model="searchArr.area_park"
                  :options="areas"
                  size="mini"
                  clearable
                  filterable
                  :props="{ expandTrigger: 'hover' }"
                  style="width: 100%"
                >
                </el-cascader>
              </el-col>
              <el-col :span="2" class="options-second">订单套餐</el-col>
              <el-col :span="3" class="options">
                <el-select
                  :filterable="true"
                  collapse-tags
                  v-model="searchArr.order_combo"
                  placeholder="请选择订单套餐"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="item in combos"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" class="options-second">服务过期</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.server_end" size="mini">
                  <el-radio-button :label="1">未过期</el-radio-button>
                  <el-radio-button :label="2">已过期</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">客户意向</el-col>
              <el-col :span="4" class="options">
                <el-radio-group v-model="searchArr.satisfy" size="mini">
                  <el-radio-button label="1">A</el-radio-button>
                  <el-radio-button label="2">B</el-radio-button>
                  <el-radio-button label="3">C</el-radio-button>
                  <el-radio-button label="4">D</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">服务状态</el-col>
              <el-col :span="8" class="options">
                <el-radio-group v-model="searchArr.server_status" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">服务中</el-radio-button>
                  <el-radio-button :label="3">交接入</el-radio-button>
                  <el-radio-button :label="4">流失</el-radio-button>
                  <el-radio-button :label="5">暂停</el-radio-button>
                  <el-radio-button :label="6">停止</el-radio-button>
                </el-radio-group>
              </el-col>

              <el-col :span="2" class="options-first">沟通关键词</el-col>
              <el-col :span="3" class="options">
                <el-cascader
                  v-model="searchArr.chat_keyword"
                  :options="keyWordsCates"
                  size="mini"
                  clearable
                  filterable
                  :props="{
                    expandTrigger: 'hover',
                    multiple: true,
                    emitPath: true,
                    label: 'label',
                    value: 'value',
                  }"
                  style="width: 100%"
                >
                </el-cascader>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="options-first">服务开始时间</el-col>
              <el-col :span="5">
                <el-date-picker
                  v-model="searchArr.start_time"
                  type="month"
                  size="mini"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM-dd"
                  placeholder="服务开始时间"
                  style="width: 60%"
                  @change="searchArr.start_time_null = false"
                >
                </el-date-picker>
                &nbsp;&nbsp;
                <div style="display: inline-block">
                  <span>无</span>
                  <el-checkbox
                    v-model="searchArr.start_time_null"
                    size="mini"
                    @change="searchArr.start_time = ''"
                  ></el-checkbox>
                </div>
              </el-col>
              <el-col :span="2" class="options-first">服务结束时间</el-col>
              <el-col :span="6">
                <!-- <el-date-picker v-model="searchArr.end_time" type="month" size="mini" format="yyyy 年 MM 月"
                value-format="yyyy-MM-dd" placeholder="服务结束时间" style="width: 60%"
                @change="searchArr.end_time_null = false">
              </el-date-picker> -->

                <el-date-picker
                  v-model="searchArr.end_time"
                  type="monthrange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  style="width: 70%"
                  :picker-options="pickerMonthOptions"
                >
                </el-date-picker>
                &nbsp;&nbsp;
                <div style="display: inline-block">
                  <span>无</span>
                  <el-checkbox
                    v-model="searchArr.end_time_null"
                    size="mini"
                    @change="searchArr.end_time = ''"
                  ></el-checkbox>
                </div>
              </el-col>
              <el-col :span="2">代账软件</el-col>
              <el-col :span="3" class="options">
                <el-select
                  :filterable="true"
                  collapse-tags
                  v-model="searchArr.software_types"
                  placeholder="代账软件"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="17DZ">17DZ</el-option>
                  <el-option :value="2" label="云账房">云账房</el-option>
                  <el-option :value="3" label="易代账">易代账</el-option>
                  <el-option :value="4" label="其他">其他</el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-card>

          <el-card
            shadow="always"
            style="margin-bottom: 0.2rem"
            v-if="serviceThings === true"
          >
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="1" class="options-first">公积金</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.accumula_fund" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">无</el-radio-button>
                  <el-radio-button :label="3">有</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="1" class="options-second">社保</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.social_security" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">无</el-radio-button>
                  <el-radio-button :label="3">有</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="1" class="options-second">UKEY</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.is_ukey" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">否</el-radio-button>
                  <el-radio-button :label="3">是</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">购买发票</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.is_invoice_bill" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">否</el-radio-button>
                  <el-radio-button :label="3">是</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">基本户信息表</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.triple_agreement" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">无</el-radio-button>
                  <el-radio-button :label="3">有</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">纳税规模</el-col>
              <el-col :span="4" class="options">
                <el-radio-group v-model="searchArr.tax_scale" size="mini">
                  <el-radio-button :label="1">小规模纳税人</el-radio-button>
                  <el-radio-button :label="2">一般纳税人</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">执照授权</el-col>
              <el-col :span="2" class="options">
                <el-radio-group v-model="searchArr.license_auth" size="mini">
                  <el-radio-button :label="1">否</el-radio-button>
                  <el-radio-button :label="2">是</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="1" class="options-second">档案号</el-col>
              <el-col :span="2" class="options">
                <el-radio-group v-model="searchArr.archives" size="mini">
                  <el-radio-button :label="1">有</el-radio-button>
                  <el-radio-button :label="2">无</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">经营状态</el-col>
              <el-col :span="5" class="options">
                <el-radio-group v-model="searchArr.manage_forms" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">存续</el-radio-button>
                  <el-radio-button :label="3">吊销</el-radio-button>
                  <el-radio-button :label="4">注销</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" style="line-height: 0.6rem">是否关注</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.is_subscribe" size="mini">
                  <el-radio-button :label="1">未关注</el-radio-button>
                  <el-radio-button :label="2">已关注</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">是否绑定</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.is_bind" size="mini">
                  <el-radio-button :label="1">未绑定</el-radio-button>
                  <el-radio-button :label="2">已绑定</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <!-- <el-col :span="2" class="options-first">开票单位</el-col>
              <el-col :span="5" class="options">
                <el-radio-group v-model="searchArr.invoice_company" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">我司开票</el-radio-button>
                  <el-radio-button :label="3">客户自开</el-radio-button>
                </el-radio-group>
              </el-col> -->
              <el-col :span="1" style="line-height: 0.6rem">CA开户</el-col>
              <el-col :span="5" class="options">
                <el-radio-group v-model="searchArr.open_account" size="mini">
                  <el-radio-button :label="1">未知</el-radio-button>
                  <el-radio-button :label="2">否</el-radio-button>
                  <el-radio-button :label="3">是</el-radio-button>
                  <el-radio-button :label="4">执照失效</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" style="line-height: 0.6rem">企业微信</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.wx_work_bind" size="mini">
                  <el-radio-button :label="1">未绑定</el-radio-button>
                  <el-radio-button :label="2">已绑定</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-card>

          <el-card
            shadow="always"
            style="margin-bottom: 0.2rem"
            v-if="serviceAccount === true"
          >
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="3" class="options-first">网报账号登录方式</el-col>
              <el-col :span="5" class="options">
                <el-radio-group v-model="searchArr.login_way" size="mini">
                  <el-radio-button :label="1">企业登录</el-radio-button>
                  <el-radio-button :label="2">CA登录</el-radio-button>
                  <el-radio-button :label="3">证书登录</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="3" class="options-second">网报账号登录账号</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.login_account" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="3" class="options-second">网报账号登录密码</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.login_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="1" class="options-first">CA密码</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.ca_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="3" class="options-second">网报账号登录身份</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.login_identity" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">自然人身份状态</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.natural_identity" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">自然人密码状态</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.natural_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">电子税务局密码</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.my_electronic_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">数字证书密码</el-col>
              <el-col :span="3" class="options">
                <el-radio-group
                  v-model="searchArr.digital_certificate_password"
                  size="mini"
                >
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">证书登录身份</el-col>
              <el-col :span="6" class="options">
                <el-radio-group v-model="searchArr.digital_identity" size="mini">
                  <el-radio-button :label="1">财务负责人</el-radio-button>
                  <el-radio-button :label="2">法定代表人</el-radio-button>
                  <el-radio-button :label="3">办税员</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">证书登录账号</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.digital_account" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" style="line-height: 0.6rem">证书登录密码</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.digital_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="3" class="options-second">个税申报登录方式</el-col>
              <el-col :span="6" class="options">
                <el-radio-group v-model="searchArr.income_tax_way" size="mini">
                  <el-radio-button :label="1">个税网报密码登录</el-radio-button>
                  <el-radio-button :label="2">实名账号密码登录</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0.2rem">
              <el-col :span="2" class="options-first">个税申报密码</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.income_tax_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">实名登录账号</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.income_real_account" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="2" class="options-second">实名登录密码</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.income_real_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="3" class="options-second">社保申报登录方式</el-col>
              <el-col :span="3" class="options">
                <el-radio-group v-model="searchArr.social_account" size="mini">
                  <el-radio-button :label="1">社保网报密码登录</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="options-first">社保申请密码</el-col>
              <el-col :span="3">
                <el-radio-group v-model="searchArr.social_password" size="mini">
                  <el-radio-button :label="1">已更新</el-radio-button>
                  <el-radio-button :label="2">未更新</el-radio-button>
                </el-radio-group>
              </el-col>
              <el-col :span="1" class="options-second">地区</el-col>
              <el-col :span="3">
                <el-select
                  filterable
                  v-model="searchArr.provinces_code"
                  placeholder="请选择省"
                  clearable
                  size="mini"
                  @change="addresscities"
                >
                  <el-option
                    v-for="item in provincesArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select
                  v-model="searchArr.city_code"
                  size="mini"
                  clearable
                  @change="addresstowns"
                >
                  <el-option
                    v-for="item in cityArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select v-model="searchArr.area_code" size="mini" clearable>
                  <el-option
                    v-for="item in areaArr"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-card>
          <el-row style="text-align: center">
            <el-col>
              <el-button type="primary" size="mini" @click="handleGetSearchData"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleClearSearchData"
                >清除</el-button
              >
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 300px)" :data="finances" ref="finance_table" style="width: 100%" border>
        <el-table-column label="公司名称" width="310" fixed>
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.company_name" placement="top">
              <div class="company_hover">
                <span class="count_style">
                  <el-link type="primary" @click="fhandleCompanyInfoOpen(scope.row.id)">{{
                    scope.row.company_name
                  }}</el-link
                  ><el-tooltip class="item" effect="dark" content="复制" placement="top"
                    ><i
                      class="el-icon-document-copy"
                      style="margin-left: 0.1rem; cursor: pointer"
                      @click="copySome(scope.row.company_name)"
                    ></i
                  ></el-tooltip>
                </span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column
          prop="fin_table.software_types"
          label="代账软件"
          v-if="setField.indexOf('software_types') !== -1"
          :fixed="selectedColumns.indexOf('software_types') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.com_fiscal_tax
                  ? scope.row.com_fiscal_tax.software_types === 1
                    ? "17DZ"
                    : scope.row.com_fiscal_tax.software_types === 2
                    ? "云账房"
                    : scope.row.com_fiscal_tax.software_types === 3
                    ? "易代账"
                    : scope.row.com_fiscal_tax.software_types === 5
                    ? "融易算"
                    : "其他"
                  : "未知"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.fin_charges"
          label="收费标准"
          width="110"
          :fixed="selectedColumns.indexOf('fin_charges') !== -1"
          v-if="setField.indexOf('fin_charges') !== -1"
        >
          <template slot-scope="scope">
            <el-tooltip
              content="双击修改"
              placement="top"
              v-if="!needEditStatus[scope.row.id]"
            >
              <span
                @dblclick="toEdit(scope.row.com_fiscal_tax.fin_charges, scope.row.id)"
                class="hide-style"
                v-if="scope.row.com_fiscal_tax"
                >{{
                  scope.row.com_fiscal_tax.fin_charges
                    ? scope.row.com_fiscal_tax.fin_charges
                    : "---"
                }}</span
              >
              <span class="hide-style" v-else @dblclick="toEdit('', scope.row.id)"
                >---</span
              >
            </el-tooltip>
            <edit-input
              v-if="needEditStatus[scope.row.id] === true"
              :price="needPrice"
              :cid="needCid"
              @updatePrice="doUpdatePrice"
              @revert="revert"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.start_time"
          label="服务开始时间"
          width="110"
          :fixed="selectedColumns.indexOf('start_time') !== -1"
          v-if="setField.indexOf('start_time') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.start_time : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.end_time"
          label="服务到期时间"
          width="130"
          v-if="setField.indexOf('end_time') !== -1"
          :fixed="selectedColumns.indexOf('end_time') !== -1"
          sortable
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.end_time : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.legal_name"
          label="法定代表人"
          width="120"
          :fixed="selectedColumns.indexOf('legal_name') !== -1"
          v-if="setField.indexOf('legal_name') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.legal_name : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.legal_phone"
          label="法人电话"
          width="170"
          :fixed="selectedColumns.indexOf('legal_phone') !== -1"
          v-if="setField.indexOf('legal_phone') !== -1"
        >
          <template slot-scope="scope">
              <!-- <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.legal_phone : ""
              }}</span> -->
              <phone-com v-if="scope.row.fin_table && scope.row.fin_table.legal_phone"
                  :comPhone="scope.row.fin_table.legal_phone"
                  :vagaryPhone="scope.row.fin_table.vagary_phone"
                  style="display: inline-block"
                />
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.finance_user"
          label="财务负责人（网厅）"
          width="140"
          :fixed="selectedColumns.indexOf('finance_user') !== -1"
          v-if="setField.indexOf('finance_user') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.finance_user : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.tax_scale"
          label="纳税规模"
          width="100"
          :fixed="selectedColumns.indexOf('tax_scale') !== -1"
          v-if="setField.indexOf('tax_scale') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table
                  ? scope.row.fin_table.tax_scale
                    ? scope.row.fin_table.tax_scale === 2
                      ? "一般纳税人"
                      : "小规模"
                    : "未知"
                  : ""
              }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fin_table.server_status"
          label="服务状态"
          :fixed="selectedColumns.indexOf('server_status') !== -1"
          v-if="setField.indexOf('server_status') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.server_status : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.is_ukey"
          label="购买UKEY"
          width="100"
          :fixed="selectedColumns.indexOf('is_ukey') !== -1"
          v-if="setField.indexOf('is_ukey') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.is_ukey : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.is_invoice_bill"
          label="购买发票"
          :fixed="selectedColumns.indexOf('is_invoice_bill') !== -1"
          v-if="setField.indexOf('is_invoice_bill') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.is_invoice_bill : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.finance_buut_join"
          label="财税对接"
          :fixed="selectedColumns.indexOf('finance_buut_join') !== -1"
          v-if="setField.indexOf('finance_buut_join') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.finance_buut_join : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.triple_agreement"
          label="基本户信息表"
          :fixed="selectedColumns.indexOf('triple_agreement') !== -1"
          v-if="setField.indexOf('triple_agreement') !== -1"
          width="140"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.triple_agreement : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.back_bill_card"
          label="回单卡"
          :fixed="selectedColumns.indexOf('back_bill_card') !== -1"
          v-if="setField.indexOf('back_bill_card') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.back_bill_card : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.social_security"
          label="社保"
          :fixed="selectedColumns.indexOf('social_security') !== -1"
          v-if="setField.indexOf('social_security') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.social_security : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.accumula_fund"
          label="公积金"
          :fixed="selectedColumns.indexOf('accumula_fund') !== -1"
          v-if="setField.indexOf('accumula_fund') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.accumula_fund : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fin_table.open_account"
          label="CA开户"
          :fixed="selectedColumns.indexOf('open_account') !== -1"
          v-if="setField.indexOf('open_account') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.fin_table ? scope.row.fin_table.open_account : ""
              }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="com_fiscal_tax.service_advisor"
          label="财税顾问"
          width="120px"
          :fixed="selectedColumns.indexOf('service_advisor') !== -1"
          v-if="setField.indexOf('service_advisor') !== -1"
        >
          <template slot-scope="scope">
            <span class="hide-style">{{
                scope.row.service_advisory.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="com_fiscal_tax.leader"
          label="财税负责人"
          width="120px"
          :fixed="selectedColumns.indexOf('leader') !== -1"
          v-if="setField.indexOf('leader') !== -1"
        >
          <template slot-scope="scope">
            <span class="hide-style">{{
                scope.row.leader.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="com_fiscal_tax.acc"
          label="理票会计"
          width="120px"
          :fixed="selectedColumns.indexOf('acc') !== -1"
          v-if="setField.indexOf('acc') !== -1"
        >
          <template slot-scope="scope">
            <span class="hide-style">{{
                scope.row.acc.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="com_fiscal_tax.advisory"
          label="记账报税会计"
          width="120px"
          :fixed="selectedColumns.indexOf('advisory') !== -1"
          v-if="setField.indexOf('advisory') !== -1"
        >
          <template slot-scope="scope">
            <span class="hide-style">{{
                scope.row.advisory.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="com_fiscal_tax.ass"
          label="客服会计"
          width="120px"
          :fixed="selectedColumns.indexOf('ass') !== -1"
          v-if="setField.indexOf('ass') !== -1"
        >
          <template slot-scope="scope">
            <span class="hide-style">{{
                scope.row.ass.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="com_fiscal_tax.invoice"
          label="开票会计"
          width="120px"
          :fixed="selectedColumns.indexOf('invoice') !== -1"
          v-if="setField.indexOf('invoice') !== -1"
        >
          <template slot-scope="scope">
            <span class="hide-style">{{
                scope.row.invoice.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属业务"
          width="120px"
          :fixed="selectedColumns.indexOf('saler') !== -1"
          v-if="setField.indexOf('saler') !== -1"
        >
          <template slot-scope="scope">
              <span class="hide-style">{{
                scope.row.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ')
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否委托代账(奉贤)"
          width="150"
          :fixed="selectedColumns.indexOf('is_trust_agent') !== -1"
          v-if="setField.indexOf('is_trust_agent') !== -1"
        >
          <template slot-scope="scope">
              <span class="count_style">{{
                scope.row.is_trust_agent === 0 ? "否" : "是"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否委托代账(静安)"
          width="150"
          :fixed="selectedColumns.indexOf('is_agent_acc_finance') !== -1"
          v-if="setField.indexOf('is_agent_acc_finance') !== -1"
        >
          <template slot-scope="scope">
              <span class="count_style">{{
                scope.row.is_agent_acc_finance === 0 ? "否" : "是"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user.name"
          label="用户姓名"
          width="150"
          :fixed="selectedColumns.indexOf('name') !== -1"
          v-if="setField.indexOf('name') !== -1"
        >
          <template slot-scope="scope">
              <span class="count_style">{{
                scope.row.user ? scope.row.user.name : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user.phone"
          label="用户手机"
          width="170"
          :fixed="selectedColumns.indexOf('phone') !== -1"
          v-if="setField.indexOf('phone') !== -1"
        >
          <template slot-scope="scope">
              <!-- <span class="count_style">{{
                scope.row.user ? scope.row.user.phone : ""
              }}</span> -->
              <phone-com v-if="scope.row.user && scope.row.user.phone"
                  :comPhone="scope.row.user.phone"
                  :vagaryPhone="scope.row.user.vagary_phone"
                  style="display: inline-block"
                />
          </template>
        </el-table-column>
        <el-table-column
          prop="user.is_auth"
          label="是否阅读须知"
          width="120"
          :fixed="selectedColumns.indexOf('is_auth') !== -1"
          v-if="setField.indexOf('is_auth') !== -1"
        >
          <template slot-scope="scope">
              <span class="count_style">{{
                scope.row.user
                  ? scope.row.user.is_auth === 2
                    ? "已阅读"
                    : "未阅读"
                  : "未阅读"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oauth.subscribe"
          label="是否关注公众号"
          width="150"
          :fixed="selectedColumns.indexOf('subscribe') !== -1"
          v-if="setField.indexOf('subscribe') !== -1"
        >
          <template slot-scope="scope">
              <span class="count_style">{{
                scope.row.oauth
                  ? scope.row.oauth.subscribe === 1
                    ? "已关注"
                    : "未关注"
                  : "未关注"
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fin_table.other_remark" label="备注信息" width="150" 
          :fixed="selectedColumns.indexOf('other_remark') !== -1"
        >
          <template slot-scope="scope">
              <span class="count_style">{{
                scope.row.fin_table ? scope.row.fin_table.other_remark : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-tooltip v-if="!scope.row.com_fiscal_tax" class="item" effect="dark" content="添加服务" placement="top">
                <el-button
                  type="text"
                  size="medium"
                  @click="handleAddServer(scope.$index, scope.row)"
                  >添加</el-button
                >
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" content="编辑服务" placement="top">
                <el-button
                  type="text"
                  size="medium"
                  @click="handleEditServer(scope.$index, scope.row)"
                  >编辑</el-button
                >
              </el-tooltip>
              <el-dropdown
                trigger="click"
                style="margin-left: 0.4rem; top: 0.04rem; cursor: pointer; color: #409eff"
              >
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleEditFinance(scope.$index, scope.row)"
                    ><span><img class="icon-class" src="/static/edit.svg" /></span
                    >编辑信息</el-dropdown-item>
                  <el-dropdown-item @click.native="handleContinueOpen(scope.$index, scope.row)">
                    <span><img class="icon-class" src="/static/fee_again.svg" /></span
                    >商机-建议-续费</el-dropdown-item>
                  <el-dropdown-item @click.native="handleChatOpen(scope.row.chat_com, scope.row.company_name)"
                    :disabled="scope.row.chat_com ? false : true"
                  >
                    <span><img class="icon-class" src="/static/chat_rec.svg" /></span
                    >聊天记录</el-dropdown-item>
                  <el-dropdown-item @click.native="handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)"
                    :disabled="scope.row.wx_work_chat_com ? false : true"
                  >
                    <span><img class="icon-class" src="/static/chat_record.svg" /></span
                    >企业微信群聊天记录</el-dropdown-item>
                  <el-dropdown-item @click.native="handCallLogsOpen(scope.row)">
                    <span><img class="icon-class" src="/static/tel_record.svg" /></span
                    >电话联系记录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="tr mt-10"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>
    <el-dialog title="导入信息" :visible.sync="dialogFormVisible">
      <div style="padding: 0.5rem 1rem">
        <p style="color: #409eff; font-size: medium">
          服务开始时间共导入成功<strong>{{ start_num }}</strong
          >条
        </p>
        <p style="color: #409eff; font-size: medium">
          服务到期时间共导入成功<strong>{{ end_num }}</strong
          >条
        </p>
        <p style="color: #f56c6c; font-size: small; margin-top: 0.2rem">
          公司名称未匹配<strong>{{ companyName_notRight.length }}</strong
          >个
          <el-button
            v-if="companyName_notRight.length > 0"
            type="warning"
            size="mini"
            @click="exportCompanyName_notRight"
          >
            导出
          </el-button>
        </p>
        <el-row style="margin-top: 0.2rem">
          <el-col
            style="margin-top: 0.1rem"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="{ span: '4-8' }"
            :xl="6"
            v-for="(item, index) in companyName_notRight"
            :key="index"
          >
            <el-tooltip class="item" effect="dark" :content="item" placement="top">
              <span
                style="
                  display: inline-block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 200px;
                "
                >{{ item }}</span
              >
            </el-tooltip></el-col
          >
        </el-row>
        <p style="color: #f56c6c; font-size: small; margin-top: 0.2rem">
          服务结束时间格式不正确<strong>{{ endTime_notRight.length }}</strong
          >个
          <el-button
            v-if="endTime_notRight.length > 0"
            type="warning"
            size="mini"
            @click="exportEndTime_notRight"
          >
            导出
          </el-button>
        </p>
        <el-row style="margin-top: 0.2rem">
          <el-col
            style="margin-top: 0.1rem"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="{ span: '4-8' }"
            :xl="6"
            v-for="(item, index) in endTime_notRight"
            :key="index"
          >
            <el-tooltip class="item" effect="dark" :content="item" placement="top">
              <span
                style="
                  display: inline-block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 200px;
                "
                >{{ item }}</span
              >
            </el-tooltip></el-col
          >
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="closeAndClear">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="导入结果"
      :before-close="handleCloseDialogFormVisibleResult"
      :visible.sync="dialogFormVisibleResult"
    >
      <div style="padding: 0.5rem 1rem">
        <p style="color: #409eff; font-size: medium">
          共导入成功<strong>{{ import_succ_num }}</strong
          >条
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="closeAndClearResult"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="导入结果"
      :before-close="handleCloseDialogFormVisibleResult"
      :visible.sync="dialogFormVisibleResult"
    >
      <div style="padding: 0.5rem 1rem">
        <p style="color: #409eff; font-size: medium">
          共导入成功<strong>{{ start_num_new }}</strong
          >条
        </p>
        <!-- <p style="color: #409eff; font-size: medium">
          服务到期时间共导入成功<strong>{{ end_num }}</strong>条
        </p> -->
        <p style="color: #f56c6c; font-size: small; margin-top: 0.2rem">
          <strong>{{ companyName_notRight_new.length }}</strong
          >家公司不在系统:
          <!-- <el-button v-if="companyName_notRight.length > 0" type="warning" size="mini"
            @click="exportCompanyName_notRight">
            导出
          </el-button> -->
        </p>
        <el-row style="margin-top: 0.2rem">
          <el-col
            style="margin-top: 0.1rem"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="{ span: '4-8' }"
            :xl="6"
            v-for="(item, index) in companyName_notRight_new"
            :key="index"
          >
            <el-tooltip class="item" effect="dark" :content="item" placement="top">
              <span
                style="
                  display: inline-block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 200px;
                "
                >{{ item }}</span
              >
            </el-tooltip></el-col
          >
        </el-row>
        <!-- <p style="color: #f56c6c; font-size: small; margin-top: 0.2rem">
          服务结束时间格式不正确<strong>{{ endTime_notRight.length }}</strong>个
          <el-button v-if="endTime_notRight.length > 0" type="warning" size="mini" @click="exportEndTime_notRight">
            导出
          </el-button>
        </p> -->
        <!-- <el-row style="margin-top: 0.2rem">
          <el-col style="margin-top: 0.1rem" :xs="24" :sm="12" :md="8" :lg="{ span: '4-8' }" :xl="6"
            v-for="(item, index) in endTime_notRight" :key="index">
            <el-tooltip class="item" effect="dark" :content="item" placement="top">
              <span style="
                  display: inline-block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 200px;
                ">{{ item }}</span>
            </el-tooltip></el-col>
        </el-row> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="closeAndClearResult"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <el-drawer
      :title="'商机-建议-续费【' + companyName + '】'"
      :visible.sync="continueDrawer"
      direction="rtl"
      :before-close="handleConBeforeClose"
      size="40%"
    >
      <div class="m-tabs-content" style="padding-left: 0.4rem; padding-right: 0">
        <el-tabs v-model="activeConName" type="border-card">
          <el-tab-pane label="商机" name="first">
            <div class="tabs_line">
              <div class="lines"></div>
              <h3 class="tabs-title">新增商机</h3>
            </div>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="6" class="m-label">商机内容：</el-col>
              <el-col :span="16" class="m-label">
                <el-select
                  multiple
                  :filterable="true"
                  v-model="addChangeData.bussin_content"
                  placeholder="请选择商机内容 可多选"
                  :size="inputSize"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in bussiness_content"
                    :key="index"
                    :label="item.bussin_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label" style="display: flex">商机分配：</el-col>
              <el-col :span="16" class="m-label">
                <el-cascader
                  style="width: 100%"
                  v-model="addChangeData.uid"
                  placeholder="此项不选默认不分配   可选择将商机分配给指定人员"
                  :options="users"
                  size="mini"
                  :props="{ expandTrigger: 'hover', emitPath: false }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
                
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">
                <el-tooltip content="紧急程度：" placement="top">
                  <span class="count_style">紧急程度：</span>
                </el-tooltip>
              </el-col>
              <el-col :span="16" class="m-label">
                <el-radio-group v-model="addChangeData.urgency" :size="inputSize">
                  <el-radio-button :label="1">普通</el-radio-button>
                  <el-radio-button :label="2">紧急</el-radio-button>
                  <el-radio-button :label="3">重要</el-radio-button>
                  <el-radio-button :label="4">特殊</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">其他备注：</el-col>
              <el-col :span="16">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model="addChangeData.remark"
                  clearable
                ></el-input>
              </el-col>
            </el-row>
            <el-row class="mt-10 tr">
              <el-button type="primary" :size="inputSize" @click="handleAddChangeSave"
                >添加</el-button
              >
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="建议" name="second">
            <div class="tabs_line">
              <div class="lines"></div>
              <h3 class="tabs-title">新增建议</h3>
            </div>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="6" class="m-label">开始时间：</el-col>
              <el-col :span="16">
                <el-date-picker
                  v-model="suggestData.start_time"
                  type="month"
                  :size="inputSize"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM-dd"
                  placeholder="选择服务开始时间"
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">过期时间：</el-col>
              <el-col :span="16">
                <el-date-picker
                  v-model="suggestData.end_time"
                  type="month"
                  :size="inputSize"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM-dd"
                  placeholder="选择服务过期时间"
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">当前套餐：</el-col>
              <el-col :span="16" class="m-label">
                <el-select
                  :filterable="true"
                  v-model="suggestData.current_combo"
                  placeholder="请选择当前服务的套餐"
                  :size="inputSize"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in combos"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">当前单品：</el-col>
              <el-col :span="16" class="m-label">
                <el-select
                  multiple
                  :filterable="true"
                  v-model="suggestData.current_item"
                  placeholder="请选择当前服务的单品"
                  :size="inputSize"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in items"
                    :key="index"
                    :label="item.item_name"
                    :value="item.item_id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">建议内容：</el-col>
              <el-col :span="16">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model="suggestData.suggest_content"
                  clearable
                ></el-input>
              </el-col>
            </el-row>
            <el-row class="mt-10 tr">
              <el-button type="primary" :size="inputSize" @click="handleAddSuggestSave"
                >添加</el-button
              >
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="续费" name="third">
            <div class="tabs_line">
              <div class="lines"></div>
              <h3 class="tabs-title">服务续费</h3>
            </div>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="6" class="m-label">开始时间：</el-col>
              <el-col :span="16">
                <el-date-picker
                  v-model="renewData.start_time"
                  type="month"
                  :size="inputSize"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM-dd"
                  placeholder="选择续期开始时间"
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">结束时间：</el-col>
              <el-col :span="16">
                <el-date-picker
                  v-model="renewData.end_time"
                  type="month"
                  :size="inputSize"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM-dd"
                  placeholder="选择续期结束时间"
                >
                </el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">订单编号：</el-col>
              <el-col :span="16">
                <el-select
                  v-model="renewData.order_id"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入订单编号"
                  :size="inputSize"
                  :remote-method="remoteMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in orderNums"
                    :key="item.id"
                    :label="item.order_num"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="mt-10 tr">
              <el-button type="primary" :size="inputSize" @click="handleAddRenewSave"
                >确认续期</el-button
              >
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="续费记录" name="fourth">
            <div class="tabs_line">
              <div class="lines"></div>
              <h3 class="tabs-title">服务续费记录</h3>
            </div>
            <el-divider></el-divider>
            <div class="blocka" v-if="renewRecords.length <= 0">暂无记录</div>
            <div class="blocka" v-else>
              <el-timeline>
                <el-timeline-item
                  v-for="(renewRecord, index) in renewRecords"
                  :key="index"
                  :timestamp="
                    renewRecord.users.username +
                    '于' +
                    renewRecord.created_at +
                    '进行了续期'
                  "
                  placement="top"
                >
                  <el-card v-if="renewRecord.orders">
                    <p>{{ "订单号：" + renewRecord.orders.order_num }}</p>
                    <p>
                      {{ "总金额：" + renewRecord.orders.total_amount + "元" }}
                    </p>
                    <p>{{ "续费时间：" + renewRecord.renew_msg }}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      title="聊天记录"
      :visible.sync="chatDrawer"
      direction="rtl"
      :before-close="handleChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat :chatId="chatId" :chatName="chatCompany"></chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="电话联系记录"
      :visible.sync="callLogsDrawer"
      direction="rtl"
      :before-close="handleCallLogsBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs
            :company="company"
            :phone="callPhone"
            :phone1="callPhone1"
            :phone2="callPhone2"
            :phone3="callPhone3"
          ></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="订单信息"
      :visible.sync="orderInfoVisible"
      direction="rtl"
      size="55%"
      :before-close="handleOrderInfoClose"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId"></order-info>
      </div>
    </el-drawer>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info
            :companyId="companyInfoId"
            :checkType="feeCheckType"
          ></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="添加服务"
      :visible.sync="addServerDrawer"
      direction="rtl"
      :before-close="handleAddServerBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row :gutter="24">
          <el-row>
            <el-col :span="5" class="tr m-label text_right">财税负责人</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.leader_id"
                placeholder="请选择财税负责人"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">理票会计</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.acc_id"
                placeholder="请选择理票会计"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">记账报税会计</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.advisory_id"
                placeholder="请选择记账报税会计"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">客服会计</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.ass_id"
                placeholder="请选择客服会计"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">综合会计</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.general_accounting_id"
                placeholder="请选择综合会计"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">开票会计</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.invoice_id"
                placeholder="请选择开票会计"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">财税顾问</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.service_advisor_id"
                placeholder="请选择财税顾问"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">共享人</el-col>
            <el-col :span="17" :offset="1">
              <el-cascader
                style="width: 100%"
                v-model="addServer.share_id"
                placeholder="请选择共享人"
                :options="users"
                size="mini"
                :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
              
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">企业税种</el-col>
            <el-col :span="17" :offset="1">
              <el-radio-group v-model="addServer.tax_type" size="mini">
                <el-radio label="2" border>小规模</el-radio>
                <el-radio label="3" border>一般纳税人</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">是否零申报</el-col>
            <el-col :span="17" :offset="1">
              <el-radio-group v-model="addServer.is_zero" size="mini">
                <el-radio :label="1" border>是</el-radio>
                <el-radio :label="2" border>否</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">记账软件</el-col>
            <el-col :span="17" :offset="1">
              <el-select
                :filterable="true"
                v-model="addServer.proxy_software"
                placeholder="记账软件"
                size="mini"
                clearable
              >
                <el-option :value="1" label="亿企赢(17DZ)">亿企赢(17DZ)</el-option>
                <el-option :value="2" label="云账房">云账房</el-option>
                <el-option :value="5" label="融易算">融易算</el-option>
                <el-option :value="3" label="易代账">易代账</el-option>
                <el-option :value="4" label="其他">其他</el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">开始时间</el-col>
            <el-col :span="17" :offset="1">
              <el-date-picker
                v-model="addServer.begin_time"
                type="month"
                size="mini"
                value-format="yyyy-MM"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">服务时间</el-col>
            <el-col :span="17" :offset="1">
              <el-date-picker
                v-model="addServer.server_time"
                type="monthrange"
                size="mini"
                value-format="yyyy-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                style="width: 70%"
              >
              </el-date-picker>
              &nbsp;&nbsp;(&nbsp;<el-checkbox
                @change="reSetGiftsLength"
                v-model="addServer.include_gifts"
                style="margin-left: 0.1rem"
                >是否包含赠送</el-checkbox
              >&nbsp;)
            </el-col>
          </el-row>
          <el-row v-if="addServer.include_gifts === true">
            <el-col :span="5" class="tr m-label text_right">赠送时长(月)</el-col>
            <el-col :span="17" :offset="1">
              <el-input
                v-model.trim="addServer.gifts_length"
                maxlength="3"
                placeholder="请输入赠送时长（月）"
                size="mini"
                clearable
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">财务收费标准</el-col>
            <el-col :span="17" :offset="1">
              <el-input
                v-model="addServer.take_money_rule"
                placeholder="请输入财务收费标准（￥）"
                size="mini"
                clearable
              ></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">增值服务</el-col>
            <el-col :span="17" :offset="1">
              <el-select
                v-model="addServer.other_server"
                @change="changeOtherServer"
                multiple
                size="mini"
                placeholder="请选择增值服务 可多选"
                @click.native="getValueAdded"
              >
                <!-- <el-option v-for="item in pri_reg" :key="item.id" :label="item.sername" :value="item.id">
                </el-option> -->
                <el-option
                  v-for="item in valueAddedOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" class="tr m-label text_right">&nbsp;</el-col>
            <el-col :span="17" :offset="1">
              <table id="value-add-table">
                <tr v-for="item in SelectedValueAddedOptions" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.price }}</td>
                  <td>
                    <el-input
                      v-model="addServer.take_money_rule_real[item.id]"
                      placeholder="请输入实际价格（￥）"
                      size="mini"
                      clearable
                    ></el-input>
                  </td>
                </tr>
              </table>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5" :offset="19">
              <el-button type="primary" @click="handleAddServerData" size="mini"
                >添加</el-button
              >
            </el-col>
          </el-row>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog
      @close="closeShowExampleDialog"
      title="导入说明"
      :visible.sync="showExampleDialog"
      :modal="false"
      width="25%"
    >
      <el-image
        style="with: 1rem; height: 3rem"
        :src="example_url"
        :preview-src-list="[example_url]"
      >
      </el-image>
    </el-dialog>

    <el-drawer
      :title="'财务登记表【' + upData.company_name + '】'"
      :visible.sync="editDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleEditBeforeClose"
      size="55%"
    >
    <div class="drawer-title" slot="title">财务登记表【 {{ upData.company_name }} 】</div>
      <div class="m-tabs-content" style="padding: 0 0 0 0.4rem">
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="automaticUpdate($event, fiscalData)"
        >
          <el-tab-pane label="财税信息" name="first">
            <el-card class="box-card" style="margin-left: 0; margin-right: 0">
              <div slot="header" class="clearfix">
                <span class="top-line">基础信息</span>
              </div>
              <div>
                <el-divider content-position="left"
                  ><span class="top-line">服务状态</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="公司名称1" placement="top">
                      <span class="count_style">公司名称1：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="18" class="m-label">
                    <el-tooltip :content="upData.company_name" placement="top">
                      <span class="count_style" style="color: #409eff">{{
                        upData.company_name
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="服务状态" placement="top">
                      <span class="count_style">服务状态：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.server_status" placement="top">
                      <span class="count_style">{{ upData.server_status }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="服务时间" placement="top">
                      <span class="count_style">服务时间：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        (upData.start_time ? upData.start_time : '未知') +
                        ' 至 ' +
                        (upData.end_time ? upData.end_time : '未知')
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        (upData.start_time ? upData.start_time : "未知") +
                        " 至 " +
                        (upData.end_time ? upData.end_time : "未知")
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">税务报到</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="操作人" placement="top">
                      <span class="count_style">操作人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="upData.tax_over_name ? upData.tax_over_name : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.tax_over_name ? upData.tax_over_name : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="完成时间" placement="top">
                      <span class="count_style">完成时间：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="upData.tax_over_at ? upData.tax_over_at : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.tax_over_at ? upData.tax_over_at : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">税种规模</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">纳税规模：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.tax_scale === 2
                          ? '一般纳税人'
                          : upData.tax_scale === 1
                          ? '小规模'
                          : '未知'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.tax_scale === 2
                          ? "一般纳税人"
                          : upData.tax_scale === 1
                          ? "小规模"
                          : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">核定税种：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="getCheckTaxCateName(upData.check_tax_cate)"
                      placement="top"
                    >
                      <span class="count_style">{{
                        getCheckTaxCateName(upData.check_tax_cate)
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">报税周期</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="增值税" placement="top">
                      <span class="count_style">增值税：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.added_set === 1
                          ? '月报'
                          : upData.added_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.added_set === 1
                          ? "月报"
                          : upData.added_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="附加税" placement="top">
                      <span class="count_style">附加税：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.addtional_set === 1
                          ? '月报'
                          : upData.addtional_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.addtional_set === 1
                          ? "月报"
                          : upData.addtional_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="个人所得税" placement="top">
                      <span class="count_style">个人所得税：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.person_set === 1
                          ? '月报'
                          : upData.person_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.person_set === 1
                          ? "月报"
                          : upData.person_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="生产经营个税" placement="top">
                      <span class="count_style">生产经营个税：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.bussin_tax_set === 1
                          ? '月报'
                          : upData.bussin_tax_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.bussin_tax_set === 1
                          ? "月报"
                          : upData.bussin_tax_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="企业所得税" placement="top">
                      <span class="count_style">企业所得税：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.company_set === 1
                          ? '月报'
                          : upData.company_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.company_set === 1
                          ? "月报"
                          : upData.company_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="印花税" placement="top">
                      <span class="count_style">印花税：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.stamp_set === 1
                          ? '月报'
                          : upData.stamp_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.stamp_set === 1
                          ? "月报"
                          : upData.stamp_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="房产税" placement="top">
                      <span class="count_style">房产税：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.house_set === 1
                          ? '月报'
                          : upData.house_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.house_set === 1
                          ? "月报"
                          : upData.house_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="财务报表" placement="top">
                      <span class="count_style">财务报表：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        upData.finance_set === 1
                          ? '月报'
                          : upData.finance_set === 2
                          ? '季报'
                          : '未设置'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.finance_set === 1
                          ? "月报"
                          : upData.finance_set === 2
                          ? "季报"
                          : "未设置"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">经营状态</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="经营状态" placement="top">
                      <span class="count_style">经营状态：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.manage_forms" placement="top">
                      <span class="count_style">{{ upData.manage_forms }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">基本情况备注：</el-col>
                  <el-col :span="20">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      v-model="upData.other_remark"
                      @change="SaveChangeMethods('other_remark', '基本情况备注')"
                      placeholder="客户或公司，重要信息"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">{{
                  "员工信息（" + getStaffIsServer(upData.staffs) + "）"
                }}</span>
              </div>
              <el-collapse v-model="staffSaleryName">
                <el-collapse-item
                  :title="'员工信息详情（' + upData.staffs.length + '）'"
                  name="1"
                >
                  <div v-if="upData.staffs.length">
                    <el-table :data="upData.staffs" style="width: 100%">
                      <el-table-column
                        prop="staff_name"
                        label="员工姓名"
                        width="100"
                      ></el-table-column>
                      <el-table-column
                        prop="staff_salary"
                        label="员工工资"
                        width="100"
                      ></el-table-column>
                      <el-table-column
                        prop="staff_phone"
                        label="员工手机"
                        width="140"
                      ></el-table-column>
                      <el-table-column width="100">
                        <template slot-scope="scope">
                          <span class="hide-style">{{
                            scope.row.is_inservice === 1 ? "在职" : "离职"
                          }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="staff_reg_at"
                        label="入职时间"
                        width="100"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <div v-else>暂无员工信息</div>
                </el-collapse-item>
              </el-collapse>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">税务资料</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="购买UKEY" placement="top">
                      <span class="count_style">购买UKEY：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.is_ukey" placement="top">
                      <span class="count_style">{{ upData.is_ukey }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="CA开户" placement="top">
                      <span class="count_style">CA开户：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.open_account" placement="top">
                      <span class="count_style">{{ upData.open_account }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="购买发票" placement="top">
                      <span class="count_style">购买发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.is_invoice_bill" placement="top">
                      <span class="count_style">{{ upData.is_invoice_bill }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="发票专用章" placement="top">
                      <span class="count_style">发票专用章：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.invoice_seal" placement="top">
                      <span class="count_style">{{ upData.invoice_seal }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="基本户信息表" placement="top">
                      <span class="count_style">基本户信息表：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.triple_agreement" placement="top">
                      <span class="count_style">{{ upData.triple_agreement }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">法人信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="法定代表人" placement="top">
                      <span class="count_style">法定代表人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="upData.legal_name ? upData.legal_name : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.legal_name ? upData.legal_name : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="法人手机" placement="top">
                      <span class="count_style">法人手机：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="upData.legal_phone ? upData.legal_phone : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.legal_phone ? upData.legal_phone : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="身份证号" placement="top">
                      <span class="count_style">身份证号：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="upData.legal_id_number ? upData.legal_id_number : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.legal_id_number ? upData.legal_id_number : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row v-if="upData.idcard_img && upData.idcard_img.length > 0">
                  <div class="demo-image__preview">
                    <span v-for="(item, index) in upData.idcard_img" :key="index">
                      <el-image
                        class="image"
                        :src="item"
                        :preview-src-list="upData.idcard_img"
                        style="margin-right: 0.1rem"
                      ></el-image>
                    </span>
                  </div>
                </el-row>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="税控托管" name="third">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span class="top-line">发票基础信息</span>
                <div style="float: right; padding: 3px 0" type="text">
                  <el-popover
                    placement="bottom-start"
                    v-model="addVisible"
                    width="320"
                    class="tr"
                  >
                    <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
                      <el-col>
                        <el-col :span="6" style="margin-top: 0.1rem">最近号段</el-col>
                        <el-col :span="18">
                          <span style="line-height: 28px">{{
                            upData.invoice_roughly
                          }}</span>
                        </el-col>
                      </el-col>
                      <el-col style="margin-bottom: 0.4rem; padding-top: 0.5rem">
                        <el-col :span="6" style="margin-top: 0.1rem">发票号段</el-col>
                        <el-col :span="18">
                          <el-input
                            v-model="addRoughly"
                            size="mini"
                            placeholder="请输入发票号段"
                          ></el-input>
                        </el-col>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="5" :offset="19">
                        <el-button type="primary" @click="handleSaveRoughly" size="mini"
                          >添加</el-button
                        >
                      </el-col>
                    </el-row>
                    <el-button
                      slot="reference"
                      size="mini"
                      type="success"
                      @click="addRoughly = ''"
                      >添加发票号段</el-button
                    >
                  </el-popover>
                </div>
              </div>
              <div>
                <el-row>
                  <el-col :span="24">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="名称" placement="top">
                        <span class="count_style">名&emsp;&emsp;&emsp;&emsp;称：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="12" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style"
                          style="color: #409eff; cursor: pointer"
                          @click="
                            copyOrderNums(
                              fiscalData.operate_address +
                                ' ' +
                                fiscalData.legaler_contact
                            )
                          "
                          >{{ fiscalData.cname }}</span
                        >
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="纳税人识别号" placement="top">
                        <span class="count_style">纳税人识别号：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style"
                          style="color: #409eff; cursor: pointer"
                          @click="
                            copyOrderNums(
                              fiscalData.operate_address +
                                ' ' +
                                fiscalData.legaler_contact
                            )
                          "
                          >{{ fiscalData.taxNumber }}</span
                        >
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="地址、电话" placement="top">
                        <span class="count_style">地址、&emsp;电话：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-tooltip content="点击复制" placement="top">
                        <span
                          class="count_style"
                          style="color: #409eff; cursor: pointer"
                          @click="
                            copyOrderNums(
                              (fiscalData.operate_address
                                ? fiscalData.operate_address
                                : '') +
                                ' ' +
                                (fiscalData.legaler_contact
                                  ? fiscalData.legaler_contact
                                  : '')
                            )
                          "
                        >
                          {{
                            (fiscalData.operate_address
                              ? fiscalData.operate_address
                              : "") +
                            " " +
                            (fiscalData.legaler_contact ? fiscalData.legaler_contact : "")
                          }}
                        </span>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="开户行及账号" placement="top">
                        <span class="count_style">开户行及账号：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col
                        :span="24"
                        v-for="(bank, index) in this.fiscalData.banks"
                        :key="index"
                        class="m-label"
                      >
                        <el-tooltip :content="'点击复制'" placement="top">
                          <span
                            class="count_style"
                            style="color: #409eff; cursor: pointer"
                            @click="copyOrderNums(bank.bank + ' ' + bank.accnumber)"
                          >
                            {{
                              bank.bank +
                              (bank.bank_type === 2 ? "（基本户）:" : "（一般户）: ") +
                              bank.accnumber
                            }}
                          </span>
                        </el-tooltip>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="8">
                      <el-col :span="9" class="m-label">
                        <el-tooltip content="收款人" placement="top">
                          <span class="count_style">收款人：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="15" class="m-label">
                        <el-tooltip content="点击复制" placement="top">
                          <span
                            class="count_style"
                            style="color: #409eff; cursor: pointer"
                            @click="copyOrderNums(fiscalData.invoice_payee)"
                            >{{ fiscalData.invoice_payee }}</span
                          >
                        </el-tooltip>
                      </el-col>
                    </el-col>
                    <el-col :span="8">
                      <el-col :span="9" class="m-label">
                        <el-tooltip content="复核人" placement="top">
                          <span class="count_style">复核人：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="15" class="m-label">
                        <el-tooltip content="点击复制" placement="top">
                          <span
                            class="count_style"
                            style="color: #409eff; cursor: pointer"
                            @click="copyOrderNums(fiscalData.invoice_reviewer)"
                            >{{ fiscalData.invoice_reviewer }}</span
                          >
                        </el-tooltip>
                      </el-col>
                    </el-col>
                    <el-col :span="8">
                      <el-col :span="9" class="m-label">
                        <el-tooltip content="开票人" placement="top">
                          <span class="count_style">开票人：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="15" class="m-label">
                        <el-tooltip content="点击复制" placement="top">
                          <span
                            class="count_style"
                            style="color: #409eff; cursor: pointer"
                            @click="copyOrderNums(fiscalData.invoice_drawer)"
                            >{{ fiscalData.invoice_drawer }}</span
                          >
                        </el-tooltip>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="12">
                      <el-col :span="9" class="m-label">
                        <el-tooltip content="增值税普通发票" placement="top">
                          <span class="count_style">增值税普通发票：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="15" class="m-label">
                        <el-tooltip
                          :content="
                            fiscalData.invoice_common === 1
                              ? '万元版'
                              : fiscalData.invoice_common === 2
                              ? '十万元版'
                              : '百万元版'
                          "
                          placement="top"
                        >
                          <span class="count_style">{{
                            fiscalData.invoice_common === 1
                              ? "万元版"
                              : fiscalData.invoice_common === 2
                              ? "十万元版"
                              : fiscalData.invoice_common === 3
                              ? "百万元版"
                              : ""
                          }}</span>
                        </el-tooltip>
                      </el-col>
                    </el-col>
                    <el-col :span="12">
                      <el-col :span="9" class="m-label">
                        <el-tooltip content="增值税专用发票" placement="top">
                          <span class="count_style">增值税专用发票：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="15" class="m-label">
                        <el-tooltip
                          :content="
                            fiscalData.invoice_special === 1
                              ? '万元版'
                              : fiscalData.invoice_special === 2
                              ? '十万元版'
                              : '百万元版'
                          "
                          placement="top"
                        >
                          <span class="count_style">{{
                            fiscalData.invoice_special === 1
                              ? "万元版"
                              : fiscalData.invoice_special === 2
                              ? "十万元版"
                              : fiscalData.invoice_special === 3
                              ? "百万元版"
                              : ""
                          }}</span>
                        </el-tooltip>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="12">
                      <el-col :span="9" class="m-label">
                        <el-tooltip content="增值税电子普通发票" placement="top">
                          <span class="count_style">增值税电子普通发票：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="15" class="m-label">
                        <el-tooltip
                          :content="
                            fiscalData.invoice_ecommon === 1
                              ? '万元版'
                              : fiscalData.invoice_ecommon === 2
                              ? '十万元版'
                              : '百万元版'
                          "
                          placement="top"
                        >
                          <span class="count_style">{{
                            fiscalData.invoice_ecommon === 1
                              ? "万元版"
                              : fiscalData.invoice_ecommon === 2
                              ? "十万元版"
                              : fiscalData.invoice_ecommon === 3
                              ? "百万元版"
                              : ""
                          }}</span>
                        </el-tooltip>
                      </el-col>
                    </el-col>
                    <el-col :span="12">
                      <el-col :span="9" class="m-label">
                        <el-tooltip content="增值税电子专用发票" placement="top">
                          <span class="count_style">增值税电子专用发票：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="15" class="m-label">
                        <el-tooltip
                          :content="
                            fiscalData.invoice_especial === 1
                              ? '万元版'
                              : fiscalData.invoice_especial === 2
                              ? '十万元版'
                              : '百万元版'
                          "
                          placement="top"
                        >
                          <span class="count_style">{{
                            fiscalData.invoice_especial === 1
                              ? "万元版"
                              : fiscalData.invoice_especial === 2
                              ? "十万元版"
                              : fiscalData.invoice_especial === 3
                              ? "百万元版"
                              : ""
                          }}</span>
                        </el-tooltip>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-collapse v-model="activeNames">
                      <el-collapse-item title="发票号段记录" name="1">
                        <el-timeline
                          v-for="(roughly, index) in upData.roughly_arr"
                          :key="index"
                        >
                          <el-timeline-item
                            :timestamp="roughly.created_at"
                            placement="top"
                          >
                            <el-card>
                              <p>{{ roughly.invoice_roughly }}</p>
                            </el-card>
                          </el-timeline-item>
                        </el-timeline>
                      </el-collapse-item>
                    </el-collapse>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">编辑发票信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="地址" placement="top">
                      <span class="count_style">地址：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.operate_address"
                      :size="inputSize"
                      @change="saveInvoiceChange('operate_address')"
                      placeholder="请填写地址"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="电话" placement="top">
                      <span class="count_style">电话：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.legaler_contact"
                      :size="inputSize"
                      @change="saveInvoiceChange('legaler_contact')"
                      placeholder="请填写法人电话"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="纳税人识别号" placement="top">
                      <span class="count_style">纳税人识别号：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <span v-if="!this.fiscalData.taxNumber">
                      <el-input
                        v-model="fiscalData.taxNumber"
                        :size="inputSize"
                        @change="saveInvoiceChange('taxNumber')"
                        placeholder="请填写纳税人识别号"
                        clearable
                      ></el-input>
                    </span>
                    <span v-else>
                      <span class="count_style">{{ fiscalData.taxNumber }}</span>
                    </span>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="收款人" placement="top">
                      <span class="count_style">收款人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.invoice_payee"
                      :size="inputSize"
                      @change="saveInvoiceChange('invoice_payee')"
                      placeholder="请填写收款人"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="复核人" placement="top">
                      <span class="count_style">复核人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.invoice_reviewer"
                      :size="inputSize"
                      @change="saveInvoiceChange('invoice_reviewer')"
                      placeholder="请填写复核人"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="开票人" placement="top">
                      <span class="count_style">开票人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.invoice_drawer"
                      :size="inputSize"
                      @change="saveInvoiceChange('invoice_drawer')"
                      placeholder="请填写开票人"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="增值税普通发票" placement="top">
                      <span class="count_style">增值税普通发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-select
                      collapse-tags
                      v-model="fiscalData.invoice_common"
                      placeholder="请选择增值税普通发票版本"
                      @change="saveInvoiceChange('invoice_common')"
                      size="mini"
                      clearable
                    >
                      <el-option :value="1" label="万元版"></el-option>
                      <el-option :value="2" label="十万元版"></el-option>
                      <el-option :value="3" label="百万元版"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip
                      content="增值税普通发票税率（免税请输入0）"
                      placement="top"
                    >
                      <span class="count_style">增值税普通发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.invoice_common_rate"
                      type="number"
                      placeholder="请选择增值税普通发票税率"
                      @change="saveInvoiceChange('invoice_common_rate')"
                      size="mini"
                      clearable
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="增值税专用发票" placement="top">
                      <span class="count_style">增值税专用发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-select
                      collapse-tags
                      v-model="fiscalData.invoice_special"
                      placeholder="请选择增值税专用发票版本"
                      @change="saveInvoiceChange('invoice_special')"
                      size="mini"
                      clearable
                    >
                      <el-option :value="1" label="万元版"></el-option>
                      <el-option :value="2" label="十万元版"></el-option>
                      <el-option :value="3" label="百万元版"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip
                      content="增值税专用发票税率（免税请输入0）"
                      placement="top"
                    >
                      <span class="count_style">增值税专用发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.invoice_special_rate"
                      type="number"
                      placeholder="请填写增值税专用发票税率"
                      @change="saveInvoiceChange('invoice_special_rate')"
                      size="mini"
                      clearable
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="增值税电子普通发票" placement="top">
                      <span class="count_style">增值税电子普通发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-select
                      collapse-tags
                      v-model="fiscalData.invoice_ecommon"
                      placeholder="请选择增值税电子普通发票版本"
                      @change="saveInvoiceChange('invoice_ecommon')"
                      size="mini"
                      clearable
                    >
                      <el-option :value="1" label="万元版"></el-option>
                      <el-option :value="2" label="十万元版"></el-option>
                      <el-option :value="3" label="百万元版"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip
                      content="增值税电子普通发票税率（免税请输入0）"
                      placement="top"
                    >
                      <span class="count_style">增值税电子普通发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.invoice_ecommon_rate"
                      type="number"
                      placeholder="请填写增值税电子普通发票税率"
                      @change="saveInvoiceChange('invoice_ecommon_rate')"
                      size="mini"
                      clearable
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="增值税电子专用发票" placement="top">
                      <span class="count_style">增值税电子专用发票：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-select
                      collapse-tags
                      v-model="fiscalData.invoice_especial"
                      placeholder="请选择增值税电子专用发票版本"
                      @change="saveInvoiceChange('invoice_especial')"
                      size="mini"
                      clearable
                    >
                      <el-option :value="1" label="万元版"></el-option>
                      <el-option :value="2" label="十万元版"></el-option>
                      <el-option :value="3" label="百万元版"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip
                      content="增值税电子专用发票税率（免税请输入0）"
                      placement="top"
                    >
                      <span class="count_style">增值税电子普通发票税率：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="fiscalData.invoice_especial_rate"
                      type="number"
                      placeholder="请填写增值税电子专用发票税率"
                      @change="saveInvoiceChange('invoice_especial_rate')"
                      size="mini"
                      clearable
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">添加银行账户信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="开户银行" placement="top">
                      <span class="count_style">开户银行：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="addBank.bank"
                      :size="inputSize"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="开户行账号" placement="top">
                      <span class="count_style">开户行账号：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="addBank.accnumber"
                      :size="inputSize"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="账户类型" placement="top">
                      <span class="count_style">账户类型：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="18" class="m-label">
                    <el-radio-group v-model="addBank.bank_type" size="mini">
                      <el-radio label="1" border>一般账户</el-radio>
                      <el-radio label="2" border>基本账户</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row class="mt-10 tr">
                  <el-button type="primary" :size="inputSize" @click="handleAddBank"
                    >添加</el-button
                  >
                </el-row>
              </div>
              <el-divider content-position="left"
                ><span class="top-line">回单卡信息</span></el-divider
              >
              <el-row>
                <el-col :span="4" class="m-label">回单卡：</el-col>
                <el-col :span="7" class="m-label">
                  <el-radio-group
                    v-model="upData.back_bill_card"
                    @change="SaveChangeMethods('back_bill_card', '回单卡')"
                    :size="inputSize"
                  >
                    <el-radio-button label="未知">未知</el-radio-button>
                    <el-radio-button label="无">无</el-radio-button>
                    <el-radio-button label="有">有</el-radio-button>
                  </el-radio-group>
                </el-col>
              </el-row>
              <span v-if="upData.back_bill_card === '有'">
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="回单卡所属银行" placement="top">
                      <span class="count_style">回单卡所属银行：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-select
                      collapse-tags
                      v-model="upData.back_card_bank"
                      placeholder="请选择回单卡所属银行"
                      @change="SaveChangeMethods('back_card_bank', '回单卡所属银行')"
                      size="mini"
                      clearable
                    >
                      <el-option value="中国银行" label="中国银行"></el-option>
                      <el-option value="建设银行" label="建设银行"></el-option>
                      <el-option value="工商银行" label="工商银行"></el-option>
                      <el-option value="农业银行" label="农业银行"></el-option>
                      <el-option value="招商银行" label="招商银行"></el-option>
                      <el-option value="交通银行" label="交通银行"></el-option>
                      <el-option value="民生银行" label="民生银行"></el-option>
                      <el-option
                        value="上海浦东发展银行"
                        label="上海浦东发展银行"
                      ></el-option>
                      <el-option value="上海银行" label="上海银行"></el-option>
                      <el-option value="上海农商银行" label="上海农商银行"></el-option>
                      <el-option value="华夏银行" label="华夏银行"></el-option>
                      <el-option value="兴业银行" label="兴业银行"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="回单卡建档编号" placement="top">
                      <span class="count_style">回单卡建档编号：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.back_card_number"
                      :size="inputSize"
                      @change="SaveChangeMethods('back_card_number', '回单卡建档编号')"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="回单卡密码" placement="top">
                      <span class="count_style">回单卡密码：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.back_card_pass"
                      :size="inputSize"
                      @change="SaveChangeMethods('back_card_pass', '回单卡密码')"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
              </span>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">税控材料</span>
              </div>
              <div>
                <el-divider content-position="left"
                  ><span class="top-line">税控托管信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="是否托管" placement="top">
                      <span class="count_style">是否托管：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.is_trust"
                      @change="SaveChangeMethods('is_trust', '税控是否托管')"
                      :size="inputSize"
                    >
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <span v-if="upData.is_trust === '是'">
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="购买发票：" placement="top">
                        <span class="count_style">购买发票：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group
                        v-model="upData.is_invoice_bill"
                        @change="SaveChangeMethods('is_invoice_bill', '购买发票')"
                        :size="inputSize"
                      >
                        <el-radio-button label="未知">未知</el-radio-button>
                        <el-radio-button label="否">否</el-radio-button>
                        <el-radio-button label="是">是</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="购买税控" placement="top">
                        <span class="count_style">购买税控：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group
                        v-model="upData.is_buy_tax"
                        @change="SaveChangeMethods('is_buy_tax', '购买税控')"
                        :size="inputSize"
                      >
                        <el-radio-button label="未知">未知</el-radio-button>
                        <el-radio-button label="否">否</el-radio-button>
                        <el-radio-button label="是">是</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="建档位置" placement="top">
                        <span class="count_style">建档位置：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group
                        v-model="upData.filing_place"
                        @change="SaveChangeMethods('filing_place', '建档位置')"
                        :size="inputSize"
                      >
                        <el-radio-button label="区域">区域</el-radio-button>
                        <el-radio-button label="编号">编号</el-radio-button>
                        <el-radio-button label="所属电脑">所属电脑</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">发票章：</el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group
                        v-model="upData.invoice_seal"
                        @change="SaveChangeMethods('invoice_seal', '发票章')"
                        :size="inputSize"
                      >
                        <el-radio-button label="未知">未知</el-radio-button>
                        <el-radio-button label="我司保管">我司保管</el-radio-button>
                        <el-radio-button label="客户自管">客户自管</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="税控类型" placement="top">
                        <span class="count_style">税控类型：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-radio-group
                        v-model="upData.tax_ctrl_type"
                        @change="SaveChangeMethods('tax_ctrl_type', '税控类型')"
                        :size="inputSize"
                      >
                        <el-radio-button label="航天金税盘">航天金税盘</el-radio-button>
                        <el-radio-button label="百旺金税盘">百旺金税盘</el-radio-button>
                        <el-radio-button label="ukey">ukey</el-radio-button>
                        <el-radio-button label="凯盈云">凯盈云</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                </span>
                <el-divider content-position="left"
                  ><span class="top-line">其他财税信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">订单套餐：</el-col>
                  <el-col :span="7">
                    <el-select
                      :filterable="true"
                      v-model="upData.order_combo"
                      placeholder="请选择订单套餐"
                      :size="inputSize"
                      @change="SaveChangeMethods('order_combo', '订单套餐')"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in combos"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">单品类型：</el-col>
                  <el-col :span="7">
                    <el-select
                      multiple
                      collapse-tags
                      :popper-append-to-body="false"
                      :filterable="true"
                      v-model="upData.order_item"
                      placeholder="请选择订单套餐"
                      :size="inputSize"
                      @change="SaveChangeMethods('order_item', '单品类型')"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in items"
                        :key="index"
                        :label="item.item_name"
                        :value="item.item_id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">执照授权：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.license_auth"
                      @change="SaveChangeMethods('license_auth', '执照授权')"
                      :size="inputSize"
                    >
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">财税对接</el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.finance_buut_join"
                      @change="SaveChangeMethods('finance_buut_join', '财税对接')"
                      :size="inputSize"
                    >
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="购买UKEY：" placement="top">
                      <span class="count_style">购买UKEY：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.is_ukey"
                      @change="SaveChangeMethods('is_ukey', '购买UKEY')"
                      :size="inputSize"
                    >
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">基本户信息表：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.triple_agreement"
                      @change="SaveChangeMethods('triple_agreement', '基本户信息表')"
                      :size="inputSize"
                    >
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="无">无</el-radio-button>
                      <el-radio-button label="有">有</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">社保：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.social_security"
                      @change="SaveChangeMethods('social_security', '社保')"
                      :size="inputSize"
                    >
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="无">无</el-radio-button>
                      <el-radio-button label="有">有</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">公积金：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.accumula_fund"
                      @change="SaveChangeMethods('accumula_fund', '公积金')"
                      :size="inputSize"
                    >
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="无">无</el-radio-button>
                      <el-radio-button label="有">有</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">CA开户：</el-col>
                  <el-col :span="20" class="m-label">
                    <el-radio-group
                      v-model="upData.open_account"
                      @change="SaveChangeMethods('open_account', '开户')"
                      :size="inputSize"
                    >
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="否">否</el-radio-button>
                      <el-radio-button label="是">是</el-radio-button>
                      <el-radio-button label="执照失效">执照失效</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="服务订单和事项" name="fifth">
            <el-tabs v-model="orderItemName">
              <el-tab-pane label="订单信息" name="first">
                <div
                  class="tabs_line"
                  style="padding-top: 0.2rem; padding-bottom: 0.2rem"
                >
                  <div class="lines"></div>
                  <h3 class="tabs-title" style="color: #409eff; font-size: 16px">
                    订单信息（{{ fiscalData.cname }}）
                  </h3>
                </div>
                <div style="padding-top: 0.2rem">
                  <el-table
                    :data="fiscalData.order_nums"
                    style="width: 100%; touch-action: none"
                    max-height="650"
                    border
                  >
                    <el-table-column label="订单号" fixed="left" width="200">
                      <template slot-scope="scope">
                        <el-tooltip
                          :content="scope.row.order_num ? scope.row.order_num : ''"
                          placement="top"
                        >
                          <div class="company_hover">
                            <span class="count_style">
                              <el-link
                                type="primary"
                                @click="handleOrderInfo(scope.row.id)"
                                >{{
                                  scope.row.order_num ? scope.row.order_num : ""
                                }}</el-link
                              >
                            </span>
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="是否为续费" fixed="left" width="100">
                      <template slot-scope="scope">
                        <el-tooltip :content="scope.row.is_renew" placement="top">
                          <span class="count_style">{{ scope.row.is_renew }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单类型">
                      <template slot-scope="scope">
                        <el-tooltip
                          :content="
                            scope.row.order_reg ? scope.row.order_reg.order_reg_name : ''
                          "
                          placement="top"
                        >
                          <span class="count_style">{{
                            scope.row.order_reg ? scope.row.order_reg.order_reg_name : ""
                          }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="下单时间">
                      <template slot-scope="scope">
                        <el-tooltip :content="scope.row.assign_at" placement="top">
                          <date-formatter :date-value="scope.row.assign_at"></date-formatter>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="顾问">
                      <template slot-scope="scope">
                        <el-tooltip
                          :content="scope.row.advisor ? scope.row.advisor.username : ''"
                          placement="top"
                        >
                          <span class="count_style">{{
                            scope.row.advisor ? scope.row.advisor.username : ""
                          }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单状态">
                      <template slot-scope="scope">
                        <el-tooltip :content="scope.row.order_status" placement="top">
                          <span class="count_style">{{ scope.row.order_status }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
              <el-tab-pane label="待办事项" name="second">
                <div
                  class="tabs_line"
                  style="padding-top: 0.2rem; padding-bottom: 0.2rem"
                >
                  <div class="lines"></div>
                  <h3 class="tabs-title" style="color: #409eff; font-size: 16px">
                    待办事项信息（{{ fiscalData.cname }}）
                  </h3>
                </div>
                <div style="padding-top: 0.2rem">
                  <el-table
                    :data="itemRecord"
                    style="width: 100%; touch-action: none"
                    max-height="650"
                    border
                  >
                    <el-table-column label="状态" fixed="left" width="60">
                      <template slot-scope="scope">
                        <el-tooltip :content="scope.row.is_stop" placement="top">
                          <span
                            v-if="scope.row.is_stop === '正常'"
                            style="color: #409eff"
                            >{{ scope.row.is_stop }}</span
                          >
                          <span v-else style="color: red">{{ scope.row.is_stop }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="进度" fixed="left" width="80">
                      <template slot-scope="scope">
                        <el-tooltip :content="scope.row.status" placement="top">
                          <span>{{ scope.row.status }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="服务类型" width="100">
                      <template slot-scope="scope">
                        <el-tooltip :content="scope.row.entries_type" placement="top">
                          <span>{{ scope.row.entries_type }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="创建人" width="220">
                      <template slot-scope="scope">
                        <el-tooltip
                          :content="
                            (scope.row.founder ? scope.row.founder.username : '') +
                            ' ' +
                            (scope.row.created_at ? scope.row.created_at : '')
                          "
                          placement="top"
                        >
                          <span>{{
                            (scope.row.founder ? scope.row.founder.username : "") +
                            " " +
                            (scope.row.created_at ? scope.row.created_at : "")
                          }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="事项" width="400">
                      <template slot-scope="scope">
                        <span v-if="scope.row.works.length">
                          <span
                            v-for="(work_items, index) in scope.row.works"
                            :key="index"
                          >
                            <el-tag style="margin-right: 5px">{{
                              work_items.item_title
                            }}</el-tag>
                          </span>
                        </span>
                        <span v-else>暂未分配事项</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="办理人" width="220">
                      <template slot-scope="scope">
                        <el-tooltip
                          :content="
                            (scope.row.executive ? scope.row.executive.username : '') +
                            ' ' +
                            (scope.row.handle_time ? scope.row.handle_time : '')
                          "
                          placement="top"
                        >
                          <span>{{
                            (scope.row.executive ? scope.row.executive.username : "") +
                            " " +
                            (scope.row.handle_time ? scope.row.handle_time : "")
                          }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column label="分配人" width="220">
                      <template slot-scope="scope">
                        <el-tooltip
                          :content="
                            (scope.row.assign ? scope.row.assign.username : '') +
                            ' ' +
                            (scope.row.assign_time ? scope.row.assign_time : '')
                          "
                          placement="top"
                        >
                          <span>{{
                            (scope.row.assign ? scope.row.assign.username : "") +
                            " " +
                            (scope.row.assign_time ? scope.row.assign_time : "")
                          }}</span>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    background
                    class="tr mt-10"
                    layout="total, prev, pager, next"
                    :hide-on-single-page="false"
                    :current-page="itemPage.currentPage"
                    :page-size="itemPage.pageSize"
                    :total="itemPage.total"
                    @current-change="handleItemCurrentChange"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane label="服务信息" name="fourth">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span class="top-line">服务时间</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="服务开始时间：" placement="top">
                      <span class="count_style">服务开始时间：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <div v-if="upData.start_time">
                      <el-date-picker
                        v-model="upData.start_time"
                        type="month"
                        :size="inputSize"
                        format="yyyy 年 MM 月"
                        value-format="yyyy-MM"
                        disabled
                        @change="SaveChangeMethods('start_time', '服务开始时间')"
                        placeholder="选择服务开始时间"
                      >
                      </el-date-picker>
                    </div>
                    <div v-else>
                      <el-date-picker
                        v-model="upData.start_time"
                        type="month"
                        :size="inputSize"
                        format="yyyy 年 MM 月"
                        value-format="yyyy-MM"
                        @change="SaveChangeMethods('start_time', '服务开始时间')"
                        placeholder="选择服务开始时间"
                      >
                      </el-date-picker>
                    </div>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="服务到期时间：" placement="top">
                      <span class="count_style">服务到期时间：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <div>
                      <el-date-picker
                        v-model="upData.end_time"
                        type="month"
                        :size="inputSize"
                        format="yyyy 年 MM 月"
                        value-format="yyyy-MM"
                        @change="SaveChangeMethods('end_time', '服务到期时间')"
                        placeholder="选择服务到期时间"
                      >
                      </el-date-picker>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">记账报税</span>
              </div>
              <div>
                <el-divider content-position="left"
                  ><span class="top-line">申报方式</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="申报方式：" placement="top">
                      <span class="count_style">申报方式：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-select
                      v-model="upData.apply_type"
                      placeholder="请选择申报方式"
                      collapse-tags
                      :popper-append-to-body="false"
                      size="mini"
                      @change="SaveChangeMethods('apply_type', '申报方式')"
                      multiple
                      clearable
                    >
                      <el-option value="1" label="电子税务局"></el-option>
                      <el-option value="2" label="介质"></el-option>
                      <el-option value="3" label="平台"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">是否有票：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.is_zero_declare"
                      @change="SaveChangeMethods('is_zero_declare', '是否有票')"
                      :size="inputSize"
                    >
                      <el-radio-button :label="1">零申报</el-radio-button>
                      <el-radio-button :label="2">有票</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">申报软件信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">申报软件账号：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.software_account"
                      size="mini"
                      @change="SaveChangeMethods('software_account', '申报软件账号')"
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">申报软件密码：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.software_pass"
                      size="mini"
                      @change="SaveChangeMethods('software_pass', '申报软件密码')"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">做账软件信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">个税密码：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.tax_password"
                      size="mini"
                      @change="SaveChangeMethods('tax_password', '个税密码')"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">做账软件账号：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.advisory_account"
                      size="mini"
                      @change="SaveChangeMethods('advisory_account', '做账软件账号')"
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">做账软件密码：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.advisory_pass"
                      size="mini"
                      @change="SaveChangeMethods('advisory_pass', '做账软件密码')"
                    ></el-input>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">税种规模</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">纳税规模：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-radio-group
                      v-model="upData.tax_scale"
                      @change="SaveChangeMethods('tax_scale', '纳税规模')"
                      :size="inputSize"
                    >
                      <el-radio-button label="1">小规模</el-radio-button>
                      <el-radio-button label="2">一般纳税人</el-radio-button>
                    </el-radio-group>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">核定税种：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-select
                      multiple
                      collapse-tags
                      :popper-append-to-body="false"
                      :filterable="true"
                      v-model="upData.check_tax_cate"
                      placeholder="请选择税种"
                      :size="inputSize"
                      @change="SaveChangeMethods('check_tax_cate', '核定税种')"
                      clearable
                    >
                      <el-option
                        v-for="(item, index) in tax_cates"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">征收方式：</el-col>
                  <el-col :span="20" class="m-label">
                    <el-radio-group
                      v-model="upData.collect_type"
                      @change="SaveChangeMethods('collect_type', '征收方式')"
                      :size="inputSize"
                    >
                      <el-radio-button label="查账征收">查账征收</el-radio-button>
                      <el-radio-button label="核定征收">核定征收</el-radio-button>
                      <el-radio-button label="个体户">个体户</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">财务报表</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="财务软件" placement="top">
                      <span class="count_style">代账软件：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-select
                      :filterable="true"
                      collapse-tags
                      v-model="fiscalData.software_types"
                      placeholder="请选择代账软件"
                      @change="changeFinanceUser('software_types')"
                      size="mini"
                      clearable
                    >
                      <el-option :value="1" label="17DZ"></el-option>
                      <el-option :value="2" label="云账房"></el-option>
                      <el-option :value="3" label="易代账"></el-option>
                      <el-option :value="4" label="其他"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="财报数据" placement="top">
                      <span class="count_style">财报数据：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-radio-group
                      v-model="fiscalData.report"
                      @change="changeFinanceUser('report')"
                      size="mini"
                    >
                      <el-radio-button label="1">是</el-radio-button>
                      <el-radio-button label="2">否</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">生产经营扣款方式</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="扣款方式：" placement="top">
                      <span class="count_style">扣款方式：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-select
                      v-model="upData.debit_type"
                      placeholder="请选择生产经营扣款方式"
                      collapse-tags
                      :popper-append-to-body="false"
                      size="mini"
                      @change="SaveChangeMethods('debit_type', '生产经营扣款方式')"
                      multiple
                      clearable
                    >
                      <el-option value="1" label="基本户信息表"></el-option>
                      <el-option value="2" label="扫码支付"></el-option>
                      <el-option value="3" label="网银扣款"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">报税周期设定</span></el-divider
                >
                <el-card class="box-card">
                  <div>
                    <el-row>
                      <el-col :span="4" class="m-label">
                        <el-tooltip content="增值税" placement="top">
                          <span class="count_style">增值税：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.added_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" :offset="1" class="m-label">
                        <el-tooltip content="附加税" placement="top">
                          <span class="count_style">附加税：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.addtional_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="4" class="m-label">
                        <el-tooltip content="个人所得税" placement="top">
                          <span class="count_style">个人所得税：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.person_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" :offset="1" class="m-label">
                        <el-tooltip content="生产经营个税" placement="top">
                          <span class="count_style">生产经营个税：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.bussin_tax_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="4" class="m-label">
                        <el-tooltip content="企业所得税" placement="top">
                          <span class="count_style">企业所得税：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.company_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" :offset="1" class="m-label">
                        <el-tooltip content="印花税" placement="top">
                          <span class="count_style">印花税：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.stamp_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="4" class="m-label">
                        <el-tooltip content="房产税" placement="top">
                          <span class="count_style">房产税：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.house_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" :offset="1" class="m-label">
                        <el-tooltip content="财务报表" placement="top">
                          <span class="count_style">财务报表：</span>
                        </el-tooltip>
                      </el-col>
                      <el-col :span="7" class="m-label">
                        <el-select v-model="upData.finance_set" size="mini" clearable>
                          <el-option :value="3" label="无"></el-option>
                          <el-option :value="1" label="月报"></el-option>
                          <el-option :value="2" label="季报"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col class="tr m-label">
                        <el-button type="primary" size="mini" @click="handleSetTaxDetail"
                          >确认</el-button
                        >
                      </el-col>
                    </el-row>
                  </div>
                </el-card>
              </div>
            </el-card>
            <!-- <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">服务人员</span>
              </div>
              <div>
                <el-divider content-position="left"
                  ><span class="top-line">服务人员信息</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="财税负责人" placement="top">
                      <span class="count_style">财税负责人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-cascader
                      style="width: 100%"
                      v-model="fiscalData.leader_id"
                      placeholder="请选择财税负责人"
                      :options="users"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      @change="changeFinanceUser('leader_id')"
                      filterable
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                    
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="理票会计" placement="top">
                      <span class="count_style">理票会计：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-cascader
                      style="width: 100%"
                      v-model="fiscalData.acc_id"
                      placeholder="请选择理票会计"
                      :options="users"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      @change="changeFinanceUser('acc_id')"
                      filterable
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                    
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="客服会计" placement="top">
                      <span class="count_style">客服会计：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-cascader
                      style="width: 100%"
                      v-model="fiscalData.ass_id"
                      placeholder="请选择客服会计"
                      :options="users"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      @change="changeFinanceUser('ass_id')"
                      filterable
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                    
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="记账报税会计" placement="top">
                      <span class="count_style">记账报税会计：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-cascader
                      style="width: 100%"
                      v-model="fiscalData.advisory_id"
                      placeholder="请选择记账报税会计"
                      :options="users"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      @change="changeFinanceUser('advisory_id')"
                      filterable
                      :filter-method="filterOptions"
                    >
                    </el-cascader>

                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="开票会计" placement="top">
                      <span class="count_style">开票会计：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-cascader
                      style="width: 100%"
                      v-model="fiscalData.invoice_id"
                      placeholder="请选择开票会计"
                      :options="users"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      @change="changeFinanceUser('invoice_id')"
                      filterable
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                    
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="财税顾问" placement="top">
                      <span class="count_style">财税顾问：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7">
                    <el-cascader
                      style="width: 100%"
                      v-model="fiscalData.service_advisor_id"
                      placeholder="请选择财税顾问"
                      :options="users"
                      size="mini"
                      :props="{ expandTrigger: 'hover', emitPath: false }"
                      clearable
                      @change="changeFinanceUser('service_advisor_id')"
                      filterable
                      :filter-method="filterOptions"
                    >
                    </el-cascader>
                  </el-col>
                  
                </el-row>
              </div>
            </el-card> -->
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">法人信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">法定代表人：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.legal_name"
                      :size="inputSize"
                      @change="SaveChangeMethods('legal_name', '法定代表人')"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">法人手机：</el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.legal_phone"
                      :size="inputSize"
                      @change="SaveChangeMethods('legal_phone', '法人手机')"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="法人身份证" placement="top">
                      <span class="count_style">法人身份证：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.legal_id_number"
                      :size="inputSize"
                      @change="SaveChangeMethods('legal_id_number', '法人身份证')"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="网厅财务负责人" placement="top">
                      <span class="count_style">网厅财务负责人：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-input
                      v-model="upData.net_finance_person"
                      :size="inputSize"
                      @change="SaveChangeMethods('net_finance_person', '网厅财务负责人')"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-card shadow="hover">
                      <el-upload
                        multiple
                        ref="upload"
                        action="#"
                        accept="image/png, image/jpeg, image/gif"
                        :limit="2"
                        :on-preview="handleLicensePreview"
                        :on-change="handleLicenseChange"
                        :on-remove="handleLicenseRemove"
                        :file-list="licenseList"
                        list-type="picture"
                        :auto-upload="false"
                      >
                        <el-link slot="trigger" type="primary"
                          >上传法人身份证(最多可上传2张)</el-link
                        >
                        <el-button
                          type="primary"
                          size="mini"
                          style="float: right"
                          @click="submitAddUpload"
                          >上传文件</el-button
                        >
                      </el-upload>
                    </el-card>
                  </el-col>
                </el-row>
                <el-row class="mt-10">
                  <el-input
                    v-paste="handleParse"
                    type="textarea"
                    placeholder="请点击此处，再粘贴复制的截图"
                  />
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">其他服务信息</span>
              </div>
              <div>
                <el-divider content-position="left"
                  ><span class="top-line">公司状态</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">经营状态：</el-col>
                  <el-col :span="20" class="m-label">
                    <el-radio-group
                      v-model="upData.manage_forms"
                      @change="SaveChangeMethods('manage_forms', '经营状态')"
                      :size="inputSize"
                    >
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="存续">存续</el-radio-button>
                      <el-radio-button label="吊销">吊销</el-radio-button>
                      <el-radio-button label="注销">注销</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">服务状态</el-col>
                  <el-col :span="20" class="m-label">
                    <el-radio-group
                      v-model="upData.server_status"
                      @change="SaveChangeMethods('server_status', '服务状态')"
                      :size="inputSize"
                    >
                      <el-radio-button label="未知">未知</el-radio-button>
                      <el-radio-button label="服务中">服务中</el-radio-button>
                      <el-radio-button label="交接入">交接入</el-radio-button>
                      <el-radio-button label="流失">流失</el-radio-button>
                      <el-radio-button label="暂停服务">暂停服务</el-radio-button>
                      <el-radio-button label="停止服务">停止服务</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="社保公积金" name="sixth"> 暂未开放 </el-tab-pane>
          <el-tab-pane label="工商基础信息" name="seventh">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>公司基础信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="公司名称2" placement="top">
                      <span class="count_style">公司名称2：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.company_name" placement="top">
                      <span class="count_style" style="color: #409eff">{{
                        upData.company_name
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="成立时间" placement="top">
                      <span class="count_style">成立时间：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.date_of_est" placement="top">
                      <span class="count_style">{{ upData.date_of_est }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="服务状态" placement="top">
                      <span class="count_style">所属区域：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.address_area" placement="top">
                      <span class="count_style">{{ upData.address_area }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="所属园区" placement="top">
                      <span class="count_style">所属园区：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip :content="upData.address_park" placement="top">
                      <span class="count_style">{{ upData.address_park }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="实际经营地址" placement="top">
                      <span class="count_style">实际经营地址：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="20" class="m-label">
                    <el-tooltip
                      :content="upData.operate_address ? upData.operate_address : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        upData.operate_address ? upData.operate_address : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span>管理归属</span>
              </div>
              <div>
                <el-divider content-position="left"
                  ><span class="top-line">所属区域</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label" style="display: flex"
                    >所属区域：</el-col
                  >
                  <el-col :span="7" class="m-label">
                    <el-cascader
                      v-model="upData.area_park"
                      :options="areas"
                      :size="inputSize"
                      :props="{ expandTrigger: 'hover' }"
                      @change="SaveChangeMethods('area_park', '所属区域')"
                    >
                    </el-cascader>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">税务局专管员</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="税务局专管员" placement="top">
                      <span class="count_style">税务局专管员：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-cascader
                      v-model="upData.tax_bureau"
                      :options="tax_bureaus"
                      :size="inputSize"
                      :props="{ expandTrigger: 'hover' }"
                      @change="SaveChangeMethods('tax_bureau', '税务局专管员')"
                    >
                    </el-cascader>
                  </el-col>
                </el-row>
                <el-divider content-position="left"
                  ><span class="top-line">市场局专管员</span></el-divider
                >
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="市场局专管员" placement="top">
                      <span class="count_style">市场局专管员：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-cascader
                      v-model="upData.market_bureau"
                      :options="market_bureaus"
                      :size="inputSize"
                      :props="{ expandTrigger: 'hover' }"
                      @change="SaveChangeMethods('market_bureau', '市场局专管员')"
                    >
                    </el-cascader>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span>工商基础信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="统一社会信用代码" placement="top">
                      <span class="count_style">统一社会信用代码：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.cre_code ? fiscalData.cre_code : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.cre_code ? fiscalData.cre_code : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="行业" placement="top">
                      <span class="count_style">行业：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.trade ? fiscalData.trade : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.trade ? fiscalData.trade : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="注册资本" placement="top">
                      <span class="count_style">注册资本：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.reg_cap ? fiscalData.reg_cap : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.reg_cap ? fiscalData.reg_cap : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="公司类型" placement="top">
                      <span class="count_style">公司类型：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        fiscalData.company_types ? fiscalData.company_types : '未知'
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.company_types ? fiscalData.company_types : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="经营期限" placement="top">
                      <span class="count_style">经营期限：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="
                        (fiscalData.formTime ? fiscalData.formTime : '未知') +
                        ' - ' +
                        (fiscalData.toTime ? fiscalData.toTime : '未知')
                      "
                      placement="top"
                    >
                      <span class="count_style">{{
                        (fiscalData.formTime ? fiscalData.formTime : "未知") +
                        " - " +
                        (fiscalData.toTime ? fiscalData.toTime : "未知")
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="是否小微企业" placement="top">
                      <span class="count_style">是否小微企业：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.isMicroEnt === 1 ? '是' : '不是'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.isMicroEnt === 1 ? "是" : "不是"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="经营范围" placement="top">
                      <span class="count_style">经营范围：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="20" class="m-label">
                    <el-tooltip :content="fiscalData.bus_scope" placement="top">
                      <span>{{ fiscalData.bus_scope }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="客户信息" name="second">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span class="top-line">客户基本信息</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="客户id" placement="top">
                      <span class="count_style">客户id：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.uid ? String(fiscalData.uid) : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.uid ? fiscalData.uid : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="客户名称" placement="top">
                      <span class="count_style">客户名称：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.uname ? fiscalData.uname : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.uname ? fiscalData.uname : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="手机号码" placement="top">
                      <span class="count_style">手机号码：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.uphone ? fiscalData.uphone : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.uphone ? fiscalData.uphone : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="4" :offset="1" class="m-label">
                    <el-tooltip content="注册时间" placement="top">
                      <span class="count_style">注册时间：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="7" class="m-label">
                    <el-tooltip
                      :content="fiscalData.regtime ? fiscalData.regtime : '未知'"
                      placement="top"
                    >
                      <span class="count_style">{{
                        fiscalData.regtime ? fiscalData.regtime : "未知"
                      }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">客户绑定</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="所属客户" placement="top">
                      <span class="count_style">所属客户：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="16" class="m-label" v-if="fiscalData.uedit === true">
                    <el-col :span="12" class="count_style">
                      {{ fiscalData.uname }}
                    </el-col>
                    <el-col :span="6">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="绑定用户"
                        placement="top"
                      >
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-edit"
                          @click="fiscalData.uedit = false"
                        ></el-button>
                      </el-tooltip>
                    </el-col>
                  </el-col>
                  <el-col :span="16" class="m-label" v-if="fiscalData.uedit === false">
                    <el-col :span="10">
                      <el-input
                        v-model="fiscalData.uid"
                        :size="inputSize"
                        clearable
                      ></el-input>
                    </el-col>
                    <el-col :span="4" :offset="2">
                      <div
                        style="color: #409eff; cursor: pointer; display: inherit"
                        @click="fiscalData.uedit = true"
                      >
                        取消
                      </div>
                    </el-col>
                    <el-col :span="2" :offset="1">
                      <div
                        style="color: #409eff; cursor: pointer; display: inherit"
                        @click="handleBindUser()"
                      >
                        确定
                      </div>
                    </el-col>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">相关公司</span>
              </div>
              <span v-if="companys.length > 0">
                <div v-for="item in companys" :key="item" class="text items">
                  {{ item }}
                </div>
              </span>
              <span v-else>
                <div class="text items">暂无关联公司</div>
              </span>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="编辑记录" name="eighth">
            <div class="blocka">
              <el-timeline>
                <el-timeline-item
                  v-for="(record, index) in records"
                  :key="index"
                  :timestamp="record.created_at"
                  placement="top"
                >
                  <el-card>
                    <p>{{ record.operate }}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-tab-pane>
          <el-tab-pane label="报税设置" name="dutiable">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span class="top-line">纳税人识别号及区域</span>
                <!---批量-->
                <el-popconfirm
                  cancel-button-text="取消"
                  confirm-button-text="确认"
                  icon="el-icon-question"
                  icon-color="red"
                  title="您确认更新吗"
                  :loading="searchLoading"
                  style="float: right; margin-right: 1.2rem"
                  @onConfirm="handlerelatedStaff(fiscalData)"
                >
                  <el-button
                    slot="reference"
                    type="primary"
                    icon="el-icon-help"
                    circle
                    size="mini"
                  ></el-button>
                </el-popconfirm>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="纳税人识别号" placement="top">
                      <span class="count_style">纳税人识别号：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="10" class="m-label">
                    <el-input
                      v-model="dutiable.taxpayer"
                      :size="inputSize"
                      placeholder="请填写纳税人识别号"
                      clearable
                      @change="dutiableChange('taxpayer')"
                    >
                    </el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="报税所属区域" placement="top">
                      <span class="count_style">报税所属区域：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="3" class="m-label">
                    <el-select
                      filterable
                      v-model="dutiable.provinces_code"
                      placeholder="请选择"
                      clearable
                      size="mini"
                      @change="addresscities"
                    >
                      <el-option
                        v-for="item in provincesArr"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3" class="m-label">
                    <el-select
                      v-model="dutiable.city_code"
                      size="mini"
                      @change="addresstowns"
                    >
                      <el-option
                        v-for="item in cityArr"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3" class="m-label">
                    <el-select
                      v-model="dutiable.area_code"
                      size="mini"
                      @change="addressarea"
                    >
                      <el-option
                        v-for="item in areaArr"
                        :key="item.id"
                        :label="item.name"
                        :value="item.code"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">财务负责人（网厅）</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="财务负责人（网厅）" placement="top">
                      <span class="count_style">财务负责人（网厅）</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="10" class="m-label">
                    <el-input
                      v-model="dutiable.finance_user"
                      :size="inputSize"
                      placeholder="请填写财务负责人（网厅）"
                      @change="dutiableChange('finance_user')"
                    >
                    </el-input>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">网报账号</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="登录方式" placement="top">
                      <span class="count_style">登录方式：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="10" class="m-label">
                    <el-radio-group
                      v-model="dutiable.login_way"
                      size="mini"
                      @change="dutiableChange('login_way')"
                    >
                      <el-radio-button label="企业登录">企业登录</el-radio-button>
                      <el-radio-button label="CA登录">CA登录</el-radio-button>
                      <el-radio-button label="证书登录">证书登录</el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="纳税人识别号" placement="top">
                      <span class="count_style">纳税人识别号：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="10" class="m-label">
                    <el-input
                      v-model="dutiable.taxpayer"
                      :size="inputSize"
                      :disabled="true"
                      placeholder="自动生成无需填写"
                      clearable
                    >
                    </el-input>
                  </el-col>
                </el-row>
                <div v-if="dutiable.login_way === '企业登录'">
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="电子税务局密码" placement="top">
                        <span class="count_style">电子税务局密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.my_electronic_password"
                        :size="inputSize"
                        placeholder="请填写电子税务局密码"
                        @change="dutiableChange('my_electronic_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="登录身份" placement="top">
                        <span class="count_style">登录身份：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.login_identity"
                        :size="inputSize"
                        placeholder="请选择登录身份"
                        clearable
                        @change="dutiableChange('login_identity')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="登录账号" placement="top">
                        <span class="count_style">登录账号：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.login_account"
                        :size="inputSize"
                        placeholder="请输入登录账号"
                        @change="dutiableChange('login_account')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="登录密码" placement="top">
                        <span class="count_style">登录密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.login_password"
                        :size="inputSize"
                        placeholder="请输入登录密码"
                        @change="dutiableChange('login_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                </div>
                <div v-else-if="dutiable.login_way === 'CA登录'">
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="ca 密码" placement="top">
                        <span class="count_style">ca 密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.ca_password"
                        :size="inputSize"
                        placeholder="请填写 c a密码"
                        @change="dutiableChange('ca_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="自然人身份" placement="top">
                        <span class="count_style">自然人身份：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.natural_identity"
                        :size="inputSize"
                        placeholder="请选择自然人身份"
                        clearable
                        @change="dutiableChange('natural_identity')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="自然人密码" placement="top">
                        <span class="count_style">自然人密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.natural_password"
                        :size="inputSize"
                        placeholder="请输入自然人密码"
                        @change="dutiableChange('natural_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="14" class="m-label" style="text-align: center">
                      <a
                        href="http://shanghai.chinatax.gov.cn/xxgk/tzgg/201807/t440890.html"
                        target="_blank"
                        >网上办税平台身份认证方式说明</a
                      >
                    </el-col>
                  </el-row>
                </div>
                <div v-else>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="数字证书密码" placement="top">
                        <span class="count_style">数字证书密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.digital_certificate_password"
                        :size="inputSize"
                        placeholder="请填写数字证书密码"
                        @change="dutiableChange('digital_certificate_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="登录身份" placement="top">
                        <span class="count_style">登录身份：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-radio-group
                        v-model="dutiable.digital_identity"
                        size="mini"
                        @change="dutiableChange('digital_identity')"
                      >
                        <el-radio-button label="财务负责人">财务负责人</el-radio-button>
                        <el-radio-button label="法定代表人">法定代表人</el-radio-button>
                        <el-radio-button label="办税员">办税员</el-radio-button>
                      </el-radio-group>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="登录账号" placement="top">
                        <span class="count_style">登录账号：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.digital_account"
                        :size="inputSize"
                        placeholder="请填写登录账号"
                        clearable
                        @change="dutiableChange('digital_account')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="登录密码" placement="top">
                        <span class="count_style">登录密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.digital_password"
                        :size="inputSize"
                        placeholder="请填写登录密码"
                        @change="dutiableChange('digital_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">个税申报</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="登录方式" placement="top">
                      <span class="count_style">登录方式：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="10" class="m-label">
                    <el-radio-group
                      v-model="dutiable.income_tax_way"
                      size="mini"
                      @change="dutiableChange('income_tax_way')"
                    >
                      <el-radio-button label="个税网报密码登录"
                        >个税网报密码登录</el-radio-button
                      >
                      <el-radio-button label="实名账号密码登录"
                        >实名账号密码登录</el-radio-button
                      >
                    </el-radio-group>
                  </el-col>
                </el-row>
                <div v-if="dutiable.income_tax_way === '个税网报密码登录'">
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="个税申报密码" placement="top">
                        <span class="count_style">个税申报密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.income_tax_password"
                        :size="inputSize"
                        placeholder="请填写个税申报密码"
                        @change="dutiableChange('income_tax_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                </div>
                <div v-else>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="实名登录账号" placement="top">
                        <span class="count_style">实名登录账号：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.income_real_account"
                        :size="inputSize"
                        placeholder="请填写实名登录账号"
                        clearable
                        @change="dutiableChange('income_real_account')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="实名登录密码" placement="top">
                        <span class="count_style">实名登录密码：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="10" class="m-label">
                      <el-input
                        v-model="dutiable.income_real_password"
                        :size="inputSize"
                        placeholder="请填写实名登录密码"
                        @change="dutiableChange('income_real_password')"
                      >
                      </el-input>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
            <el-card class="box-card" style="margin-top: 0.2rem">
              <div slot="header" class="clearfix">
                <span class="top-line">社保申报</span>
              </div>
              <div>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="登录方式" placement="top">
                      <span class="count_style">登录方式：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="10" class="m-label">
                    <el-radio
                      disabled
                      v-model="dutiable.social_account"
                      label="社保网报密码登录"
                      >社保网报密码登录</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4" class="m-label">
                    <el-tooltip content="社保申请密码" placement="top">
                      <span class="count_style">社保申请密码：</span>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="10" class="m-label">
                    <el-input
                      v-model="dutiable.social_password"
                      :size="inputSize"
                      placeholder="请填写社保申请密码"
                      @change="dutiableChange('social_password')"
                    >
                    </el-input>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <el-drawer
    :title="'修改： ' + companyName"
      :visible.sync="editServerDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleEditServerBeforeClose"
      size="50%"
    >
    <div class="drawer-title" slot="title">修改： {{ companyName }}</div>
      <service-edit :row="editData" @closeEditDrawer="closeEditDrawer" />
    </el-drawer>
    <!-- 导出选择 -->
    <el-dialog
      title="导出字段选择"
      :visible.sync="chooseExportFieldsVisible"
      :append-to-body="true"
      width="50%"
    >
      <div class="contents">
        <el-row style="margin-bottom: 0.2rem">
          <el-select
            v-model="selectedValues"
            size="small"
            multiple
            filterable
            clearable
            placeholder="请选择导出字段"
          >
            <el-option
              v-for="item in multipleFields"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="info" @click="selectAll">全选</el-button>
        <el-button size="mini" type="warning" @click="deselectAll">全不选</el-button>
        <el-button size="mini" @click="HandleDialogVisibleClose()">取 消</el-button>
        <el-button size="mini" type="primary" @click="HandleExport()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导出选择 -->
  </el-container>
</template>
<script>
import Chat from "common/Chat";
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import CompanyInfo from "common/CompanyInfo";
import EditInput from "./EditInput";
import ServiceEdit from "./ServiceEdit";
import FinanceFields from "../../lib/financeFields";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from "common/PhoneCom";
import DateFormatter from "common/DateFormatter";

export default {
  name: "FinanceTable",
  components: {
    Chat,
    WxWorkChat,
    CallLogs,
    CompanyInfo,
    OrderInfo,
    EditInput,
    ServiceEdit,
    PhoneCom,
    DateFormatter
  },
  data() {
    return {
      pickerMonthOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      feeCheckType: this.$feedBackConfig.fee_chat,
      import_succ_num: "",
      activeOpen: "",
      editDatafin: {},
      avalue: "",
      editServerDrawer: false,

      SelectedValueAddedOptions: [],
      needPrice: "",
      needEditStatus: [],
      needCid: null,
      dialogFormVisibleResult: false,
      example_url: "",
      showExampleDialog: false,
      start_num_new: "",
      companyName_notRight_new: [],
      serviceEvent: false,
      serviceThings: false,
      serviceAccount: false,
      searchLoading: false,
      dialogFormVisible: false,
      endTime_notRight: [],
      companyName_notRight: [],
      start_num: "",
      end_num: "",
      dutiable: {
        taxpayer: null,
        provinces_code: null,
        city_code: null,
        area_code: null,
        my_electronic_password: null,
        login_way: "企业登录",
        login_identity: null,
        login_account: null,
        login_password: null,
        ca_password: null,
        natural_identity: null,
        natural_password: null,
        digital_certificate_password: null,
        digital_identity: "财务负责人",
        digital_account: null,
        digital_password: null,
        income_tax_way: "个税网报密码登录",
        income_tax_password: null,
        income_real_account: null,
        income_real_password: null,
        social_account: "社保网报密码登录",
        social_password: null,
        legal_name: null,
        finance_user: null,
      },
      flag: false,
      val: false,
      provincesArr: {},
      cityArr: {},
      areaArr: {},
      accountingReportFile: [],
      businessLicenseFile: [],
      businessCopyFile: [],
      bankOpenFile: [],
      limit: 10,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      addRelated: {
        company_id: null,
        pass_and_password: null,
        registration_password: null,
        electronic_password: null,
        wage_information: null,
        accounting_report: null,
        accounting_report_file_name: null,
        business_license_original: null,
        business_license_copy: null,
        bank_opening_permit: null,
      },
      tableRelated: {
        pass_and_password: null,
        registration_password: null,
        electronic_password: null,
        wage_information: null,
        accountingBuphoto: null,
        businessBuphoto: null,
        businessCopyBuphoto: null,
        bankOpenBuphoto: null,
      },
      tableData: [],
      toBottom: true,
      oldHeight: 0,
      addRoughly: "",
      addVisible: false,
      loading: false,
      editDrawer: false,
      chatDrawer: false,
      wxChatDrawer: false,
      continueDrawer: false,
      addServerDrawer: false,
      activeNames: [1],
      activeName: "first",
      orderItemName: "first",
      activeConName: "first",
      staffSaleryName: [1],
      inputSize: "mini",
      combos: [],
      items: [],
      users: [],
      areas: [],
      setField: [],
      selectedColumns: [], // 用户选择列
      tax_cates: [],
      itemRecord: [],
      header: [],
      records: [],
      finances: [],
      renewRecords: [],
      companies: [],
      orderNums: [],
      companys: [],
      pri_reg: [],
      tax_bureaus: [],
      market_bureaus: [],
      fin_tab_data: [],
      bussiness_content: [],
      companyId: null,
      chatCompany: "",
      chatId: "",
      companyName: "",
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      searchArr: {
        end_time_null: "",
        start_time_null: "",
        company_id: "",
        start_time: "",
        end_time: "",
        finance_user: "",
        saler_id: [],
        service_advisor_id: "",
        general_accounting_id: "",
        leader_id: "",
        acc_id: "",
        ass_id: "",
        advisory_id: "",
        invoice_id: "",
        area_park: [],
        order_combo: "",
        is_ukey: "",
        is_invoice_bill: "",
        license_auth: "",
        triple_agreement: "",
        social_security: "",
        accumula_fund: "",
        manage_forms: "",
        server_status: "",
        // invoice_company: "",
        open_account: "",
        tax_scale: "",
        is_bind: "",
        is_subscribe: "",
        server_end: "",
        wx_work_bind: "",
        software_types: "",
        archives: "",
        provinces_code: "",
        city_code: "",
        area_code: "",
        login_way: "",
        taxNumber: "",
        my_electronic_password: "",
        login_identity: "",
        login_account: "",
        login_password: "",
        ca_password: "",
        natural_identity: "",
        natural_password: "",
        digital_certificate_password: "",
        digital_identity: "",
        digital_account: "",
        digital_password: "",
        income_tax_way: "",
        income_tax_password: "",
        income_real_account: "",
        income_real_password: "",
        social_account: "",
        social_password: "",
        satisfy: "",
        chat_keyword: [],
      },
      keyWordsCates: [],
      valueAddedOptions: [],
      editData: null,
      addServer: {
        cid: null,
        leader_id: null,
        acc_id: null,
        ass_id: null,
        advisory_id: null,
        invoice_id: null,
        server_time: [],
        tax_type: "",
        take_money_rule: "",
        take_money_rule_real: [],
        other_server: [],
        begin_time: "",
        is_zero: "",
        share_id: null,
        proxy_software: "",
        include_gifts: false,
        gifts_length: "",
        service_advisor_id: null,
        general_accounting_id: ''
      },
      upData: {
        index: null,
        fid: null,
        company_id: "",
        company_name: "",
        start_time: null,
        end_time: null,
        legal_name: "",
        legal_phone: "",
        legal_id_number: "",
        tax_scale: "",
        check_tax_cate: [],
        area_park: [],
        tax_password: "",
        is_ukey: "",
        is_invoice_bill: "",
        open_account: "",
        // invoice_company: "",
        order_combo: "",
        order_item: [],
        license_auth: "",
        finance_buut_join: "",
        social_security: "",
        accumula_fund: "",
        triple_agreement: "",
        back_bill_card: "",
        manage_forms: "",
        server_status: "",
        invoice_seal: "",
        invoice_roughly: "",
        roughly_arr: [],
        other_remark: "",
        added_set: "",
        addtional_set: "",
        person_set: "",
        bussin_tax_set: "",
        company_set: "",
        stamp_set: "",
        house_set: "",
        finance_set: "",
        software_account: "",
        software_pass: "",
        advisory_account: "",
        advisory_pass: "",
        date_of_est: "",
        address_area: "",
        address_park: "",
        tax_over_name: "",
        tax_over_at: "",
        is_trust: null,
        is_buy_tax: "",
        tax_ctrl_type: "",
        filing_place: "",
        back_card_bank: "",
        back_card_number: "",
        back_card_pass: "",
        collect_type: "",
        tax_bureau: [],
        market_bureau: [],
        apply_type: [],
        debit_type: [],
        idcard_img: [],
        staffs: [],
        net_finance_person: null,
        is_zero_declare: 0,
      },
      fiscalData: {
        index: null,
        uid: null,
        uname: "",
        uphone: "",
        regtime: "",
        uedit: false,
        cid: null,
        cname: "",
        banks: [],
        start_time: "",
        end_time: "",
        order_nums: "",
        services: [],
        leader_id: null,
        leader_name: "",
        acc_id: null,
        acc_name: "",
        ass_id: null,
        ass_name: "",
        advisory_id: null,
        advisory_name: "",
        invoice_id: null,
        invoice_name: "",
        service_advisor_id: null,
        general_accounting_id: null,
        service_advisor_name: "",
        saler_id: null,
        saler_name: "",
        software_types: null,
        report: null,
        legaler: "",
        legaler_contact: "",
        taxNumber: "",
        operate_address: "",
        cre_code: "",
        trade: "",
        reg_cap: "",
        company_types: "",
        fromTime: "",
        toTime: "",
        bus_scope: "",
        isMicroEnt: "",
        invoice_payee: null,
        invoice_reviewer: null,
        invoice_drawer: null,
        invoice_common: null,
        invoice_ecommon: null,
        invoice_special: null,
        invoice_especial: null,
        invoice_common_rate: null,
        invoice_ecommon_rate: null,
        invoice_special_rate: null,
        invoice_especial_rate: null,
      },
      addBank: {
        cid: null,
        bank: "",
        accnumber: "",
        bank_type: "",
      },
      addChangeData: {
        remark: "",
        uid: "",
        bussin_content: [],
        company_id: "",
        urgency: 1,
      },
      suggestData: {
        id: null,
        company_id: "",
        start_time: "",
        end_time: "",
        suggest_content: "",
        current_combo: "",
        current_item: [],
      },
      renewData: {
        id: null,
        company_id: "",
        start_time: "",
        end_time: "",
        order_id: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      itemPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      fields: [
        { id: "software_types", name: "代账软件", fixed: false },
        { id: "fin_charges", name: "收费标准", fixed: false },
        { id: "start_time", name: "服务开始时间", fixed: false },
        { id: "end_time", name: "服务结束时间", fixed: false },
        { id: "legal_name", name: "法定代表人", fixed: false },
        { id: "legal_phone", name: "法人电话", fixed: false },
        { id: "legal_id_number", name: "法人身份证", fixed: false },
        { id: "finance_user", name: "财务负责人(网厅)", fixed: false },
        { id: "tax_scale", name: "纳税规模", fixed: false },
        { id: "server_status", name: "服务状态", fixed: false },
        { id: "is_ukey", name: "购买UKEY", fixed: false },
        { id: "is_invoice_bill", name: "购买发票", fixed: false },
        // { id: "invoice_company", name: "开票单位", fixed:false },
        { id: "finance_buut_join", name: "财税对接", fixed: false },
        { id: "triple_agreement", name: "基本户信息表", fixed: false },
        { id: "back_bill_card", name: "回单卡", fixed: false },
        { id: "social_security", name: "社保", fixed: false },
        { id: "accumula_fund", name: "公积金", fixed: false },
        { id: "open_account", name: "CA开户", fixed: false },
        { id: "service_advisor", name: "财税顾问", fixed: false },
        { id: "leader", name: "财税负责人", fixed: false },
        { id: "acc", name: "理票会计", fixed: false },
        { id: "ass", name: "客服会计", fixed: false },
        { id: "general_accounting", name: "综合会计", fixed: false },
        { id: "advisory", name: "记账报税会计", fixed: false },
        { id: "invoice", name: "开票会计", fixed: false },
        { id: "saler", name: "所属业务", fixed: false },
        { id: "is_trust_agent", name: "是否委托代账(奉贤)", fixed: false },
        { id: "is_agent_acc_finance", name: "是否委托代账(静安)", fixed: false },
        { id: "name", name: "用户姓名", fixed: false },
        { id: "phone", name: "用户手机", fixed: false },
        { id: "is_auth", name: "是否阅读须知", fixed: false },
        { id: "subscribe", name: "是否关注公众号", fixed: false },
        { id: "other_remark", name: "备注信息", fixed: false },
      ],
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      orderInfoVisible: false,
      orderInfoId: null,
      licenseList: [],
      formData: null,
      companyInfoDrawer: false,
      companyInfoId: null,
      addtionData: { value: "无", label: "NULL" },
      chooseExportFieldsVisible: false,
      exportFields: [],
      multipleFields: FinanceFields.fields,
    };
  },
  created() {
    this.getFinanceSettingParams();
  },
  watch: {
    "addServer.other_server": {
      handler(n) {
        this.SelectedValueAddedOptions = [];
        var arr = [];
        if (n.length > 0) {
          this.valueAddedOptions.map((item) => {
            this.addServer.other_server.map((i) => {
              if (item.id === i) {
                arr.push(item);
              }
            });
          });
        }
        this.SelectedValueAddedOptions = arr;
      },
    },
    deep: true,
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
    usersConvert() {
      return [...this.users, this.addtionData];
    },
    selectedValues: {
      get() {
        return this.exportFields.slice();
      },
      set(val) {
        this.exportFields = this.multipleFields
          .filter((field) => val.includes(field.value))
          .map((field) => field.value);
      },
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickCollapseOutSide);
  },
  methods: {
    exportFinanceLists() {
      this.chooseExportFieldsVisible = true;
    },
    HandleExport() {
      if (this.exportFields.length <= 0) {
        this.$message.error("请选择要导出的字段信息~");
        return;
      }
      this.$axios
        .post(
          "api/admin/finance/export_finance_list",
          {
            fields: this.exportFields, // 将 exportFields 数组作为请求的数据发送到后端
          },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "财务登记表人员信息.csv";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    HandleDialogVisibleClose() {
      this.chooseExportFieldsVisible = false;
    },
    selectAll() {
      this.selectedValues = this.multipleFields.map((field) => field.value);
    },
    deselectAll() {
      this.selectedValues = [];
    },
    changeOtherServer(val) {
      this.addServer.take_money_rule_real.map((item, index) => {
        if (val.indexOf(index) === -1) {
          this.addServer.take_money_rule_real.splice(index);
        }
      });
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector(".el-collapse");
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = "";
      }
    },
    reSetGiftsLength(val) {
      if (val === false) {
        this.addServer.gifts_length = "";
      }
    },
    closeEditDrawer() {
      this.editServerDrawer = false;
      this.getFinanceData();
    },
    doSomeThing(val) {
      console.log(val);
    },
    getValueAdded() {
      this.$axios
        .get("api/system_config_value_added_get_options")
        .then(({ data }) => {
          if (data.code === 200) {
            this.valueAddedOptions = data.data;
          }
        })
        .catch();
    },
    exportEndTime_notRight() {
      this.$axios
        .post(
          "api/finance/server_date_export_endtime",
          { endTime_notRight: this.endTime_notRight },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "服务到期时间不匹配.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    exportCompanyName_notRight() {
      this.$axios
        .post(
          "api/finance/server_date_export",
          { companyName_notRight: this.companyName_notRight },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "公司名称不匹配.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    closeAndClear() {
      this.endTime_notRight = [];
      this.companyName_notRight = [];
      this.start_num = "";
      this.end_num = "";
      this.dialogFormVisible = false;
      this.getFinanceData();
    },
    closeAndClearResult() {
      this.companyName_notRight_new = [];
      this.start_num_new = "";
      this.import_succ_num = "";
      this.dialogFormVisibleResult = false;
      this.getFinanceData();
    },
    getInfo(res) {
      if (res.code === 1) {
        this.endTime_notRight = res.endTime_notRight;
        this.companyName_notRight = res.companyName_notRight;
        this.start_num = res.start_num;
        this.end_num = res.end_num;
        this.dialogFormVisible = true;
      }
    },
    handleCloseDialogFormVisibleResult(done) {
      this.closeAndClearResult();
      done();
    },
    importServiceAdvisor(param) {
      const formData = new FormData();
      formData.append("file", param.file);
      this.$axios
        .post("api/admin/finance/import_service_advisor", formData)
        .then(({ data }) => {
          if (data.code === 1) {
            this.import_succ_num = data.data.num;
            this.dialogFormVisibleResult = true;
          }
        })
        .catch((response) => {
          console.log("异常处理");
        });
    },
    upload(param) {
      const formData = new FormData();
      formData.append("file", param.file);
      this.$axios
        .post("api/finance/server_date_import", formData)
        .then(({ data }) => {
          if (data.code === 200) {
            this.start_num_new = data.data.num;
            this.companyName_notRight_new = data.data.not_exit_company;
            this.dialogFormVisibleResult = true;
          }
        })
        .catch((response) => {
          console.log("异常处理");
        });
    },
    toEdit(price, id) {
      this.needPrice = "";
      this.needCid = null;
      this.needEditStatus = [];
      this.needEditStatus.push(id);
      this.needEditStatus[id] = true;
      this.$nextTick(() => {
        this.needPrice = price;
        this.needCid = id;
      });
    },
    doUpdatePrice(price, company_id) {
      this.needEditStatus = [];
      this.finances.map((item) => {
        if (item.id === company_id) {
          item.com_fiscal_tax.fin_charges = price;
        }
      });
    },
    revert() {
      this.needEditStatus = [];
    },
    dutiableChange(val) {
      this.val = this.dutiable[val];
      this.$axios
        .get(
          "/api/admin/finance/dutiablechange?val=" +
            this.val +
            "&valname=" +
            val +
            "&company_id=" +
            this.upData.company_id
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.getFinanceData();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    addressarea(e) {
      this.dutiable.area_code = e;
      this.$axios
        .get(
          "/api/admin/finance/dutiablechangedq?provinces_code=" +
            this.dutiable.provinces_code +
            "&city_code=" +
            this.dutiable.city_code +
            "&area_code=" +
            this.dutiable.area_code +
            "&company_id=" +
            this.upData.company_id
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    addresstowns(e) {
      this.dutiable.area_code = null;
      this.areaArr = {};
      this.$axios.get("/api/admin/policy/addresstowns?cityCode=" + e).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.areaArr = data.data.area;
        }
      });
    },
    addresscities(e) {
      this.dutiable.city_code = null;
      this.dutiable.area_code = null;
      this.cityArr = {};
      this.areaArr = {};
      this.areaArr = {};
      this.$axios
        .get("/api/admin/policy/addresscities?provincesCode=" + e)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.cityArr = data.data.city;
          }
        });
    },
    automaticUpdate(val, company) {
      if (val.label === "报税设置") {
        this.$axios
          .get(
            "/api/admin/finance/dutiableyijian?taxNumber=" +
              company.taxNumber +
              "&company_id=" +
              company.cid
          )
          .then((res) => {
            const { data } = res;
            if (data.code === 0) {
              // this.$message.success(data.msg)
              this.dutiable = data.data.dutiable;
              this.fiscalData.software_types = 1;
              this.cityArr = data.data.cityObj;
              this.getFinanceData();
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    handlerelatedStaff(company) {
      this.$axios
        .get(
          "/api/admin/finance/dutiableyijian?taxNumber=" +
            company.taxNumber +
            "&company_id=" +
            company.cid
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.dutiable = data.data.dutiable;
            this.cityArr = data.data.cityObj;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    copyOrderNums(orders) {
      let oInput = document.createElement("input");
      oInput.value = orders;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    getItemIds(items) {
      let item = [];
      if (items.length <= 0) {
        return item;
      }
      for (var i = 0; i < items.length; i++) {
        item.push(items[i].item_id);
      }
      return item;
    },
    getTaxCateIds(taxCates) {
      let tax = [];
      if (taxCates.length <= 0) {
        return tax;
      }
      for (var m = 0; m < taxCates.length; m++) {
        tax.push(taxCates[m].id);
      }
      return tax;
    },
    getServiceNames(services) {
      let service = [];
      if (services.length <= 0) {
        return service;
      }
      for (var j = 0; j < services.length; j++) {
        service.push(services[j].sername);
      }
      return service;
    },
    getFinanceData() {
      this.$axios
        .get(
          "/api/finance?page=" +
            this.pageOption.currentPage +
            "&limit=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.finances = data.data.list.data;
            this.header = data.data.header;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
            this.$nextTick(() => {
              this.$refs.finance_table.doLayout();
            });
            // this.provincesArr = data.data.provinces
            // this.combos = data.data.combos
            // this.tax_cates = data.data.tax_cates
            // this.items = data.data.items
            // this.users = data.data.users
            // this.areas = data.data.areas
            // this.bussiness_content = data.data.bussiness_content
            // this.tax_bureaus = data.data.tax_bureau
            // this.market_bureaus = data.data.market_bureau
            // this.pri_reg = data.data.pri_reg
            // this.setField = []
            // if (data.data.fields.length > 0) {
            //   this.setField = data.data.fields
            // } else {
            //   for (let k = 0; k < this.fields.length; k++) {
            //     this.setField.push(this.fields[k].id)
            //   }
            // }

            // this.provincesArr = data.data.paramData.provinces
            // this.combos = data.data.paramData.combos
            // this.tax_cates = data.data.paramData.tax_cates
            // this.items = data.data.paramData.items
            // this.users = data.data.paramData.users
            // this.areas = data.data.paramData.areas
            // this.bussiness_content = data.data.paramData.bussiness_content
            // this.tax_bureaus = data.data.paramData.tax_bureau
            // this.market_bureaus = data.data.paramData.market_bureau
            // this.pri_reg = data.data.paramData.pri_reg
            // this.setField = []
            // if (data.data.paramData.fields.length > 0) {
            //   this.setField = data.data.paramData.fields
            // } else {
            //   for (let k = 0; k < this.fields.length; k++) {
            //     this.setField.push(this.fields[k].id)
            //   }
            // }
          }
        });
    },

    getFinanceSettingParams() {
      this.$axios.get("/api/finance/setting/get_setting_params").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.provincesArr = data.data.provinces;
          this.combos = data.data.combos;
          this.tax_cates = data.data.tax_cates;
          this.items = data.data.items;
          this.users = data.data.users;
          this.areas = data.data.areas;
          this.bussiness_content = data.data.bussiness_content;
          this.tax_bureaus = data.data.tax_bureau;
          this.market_bureaus = data.data.market_bureau;
          this.pri_reg = data.data.pri_reg;
          this.keyWordsCates = data.data.chat_keywordCates;
          this.setField = [];
          if (data.data.fields && data.data.fields.length > 0) {
            this.setField = data.data.fields;
          } else {
            for (let k = 0; k < this.fields.length; k++) {
              this.setField.push(this.fields[k].id);
            }
          }
          this.selectedColumns = [];
          if (data.data.fixed_columns && data.data.fixed_columns.length > 0) {
            this.selectedColumns = data.data.fixed_columns;
          }
          // else {
          //   for (let k = 0; k < this.fields.length; k++) {
          //     this.selectedColumns.push(this.fields[k].id);
          //   }
          // }
        }
      });
    },

    getFinanceRecords(fid, id) {
      this.$axios.get("/api/finance/records/" + fid + "?cid=" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.records = data.data.records;
          this.companys = data.data.companys;
        }
      });
    },
    getItemsData(cid) {
      this.$axios
        .get("/api/finance/items/" + cid + "?page=" + this.itemPage.currentPage)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.itemRecord = data.data.items.data;
            this.itemPage.total = data.data.items.total;
            this.itemPage.currentPage = data.data.items.current_page;
            this.provincesArr = data.data.provinces;
            this.cityArr = data.data.cityArr;
            this.areaArr = data.data.areaArr;
            if (data.data.dutiable === null) {
              this.dutiable.taxpayer = null;
              this.dutiable.provinces_code = null;
              this.dutiable.city_code = null;
              this.dutiable.area_code = null;
              this.dutiable.my_electronic_password = null;
              this.dutiable.login_way = "企业登录";
              this.dutiable.login_identity = null;
              this.dutiable.login_account = null;
              this.dutiable.login_password = null;
              this.dutiable.ca_password = null;
              this.dutiable.natural_identity = null;
              this.dutiable.natural_password = null;
              this.dutiable.digital_certificate_password = null;
              this.dutiable.digital_identity = "财务负责人";
              this.dutiable.digital_account = null;
              this.dutiable.digital_password = null;
              this.dutiable.income_tax_way = "个税网报密码登录";
              this.dutiable.income_tax_password = null;
              this.dutiable.income_real_account = null;
              this.dutiable.income_real_password = null;
              this.dutiable.social_account = "社保网报密码登录";
              this.dutiable.social_password = null;
              this.dutiable.legal_name = null;
              this.dutiable.finance_user = null;
            } else {
              this.dutiable = data.data.dutiable;
            }
          }
        });
    },
    saveInvoiceChange(field) {
      this.$axios
        .post("/api/finance/com_invoice/" + this.fiscalData.cid, {
          field: field,
          value: this.fiscalData[field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    SaveChangeMethods(field, fieldName) {
      let oldValue = null;
      if (field === "order_item") {
        oldValue = this.getItemIds(this.finances[this.upData.index].fin_table.item_types);
      } else if (field === "check_tax_cate") {
        oldValue = this.getTaxCateIds(
          this.finances[this.upData.index].fin_table.check_tax_cate_name
        );
      } else if (field === "start_time") {
        if (this.upData.start_time >= this.upData.end_time) {
          this.$message.error("服务到期时间不能小于服务开始时间");
          return false;
        }
      } else if (field === "end_time") {
        var startTimeValue = this.upData.start_time;
        if (!this.upData.start_time) {
          this.$message.error("请先选择服务开始时间");
          return false;
        }
        if (this.upData.start_time >= this.upData.end_time) {
          this.$message.error("服务到期时间不能小于服务开始时间");
          return false;
        }
      } else {
        oldValue = this.finances[this.upData.index].fin_table[field];
      }
      this.$axios
        .put("/api/finance/" + this.upData.fid, {
          fieldName: field,
          value: this.upData[field],
          old: oldValue,
          typeName: fieldName,
          startTimeValue: field === "end_time" ? startTimeValue : "",
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.records.unshift(data.data.record);
            this.finances[this.upData.index].fin_table = data.data.finance_table;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    changeFinanceUser(filed) {
      this.$axios
        .post("/api/finance/change_fin/" + this.fiscalData.cid, {
          filed: filed,
          value: this.fiscalData[filed],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            if (data.data) {
              this.records.unshift(data.data);
              if (filed === "saler_id") {
                this.finances[this.fiscalData.index].saler_id = this.fiscalData[filed];
              } else {
                this.finances[this.fiscalData.index].com_fiscal_tax[
                  filed
                ] = this.fiscalData[filed];
              }
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleColChange() {
      this.$axios.post("/api/finance/set_field", this.setField).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.$nextTick(() => {
            this.$refs.finance_table.doLayout();
          });
        }
      });
    },
    handleColumnSelectionChange(selectedColumns) {
      // 不添加进数据库
      // this.fields.forEach(column => {
      //   column.fixed = this.selectedColumns.includes(column.id);
      // });

      this.$axios
        .post("/api/admin/finance/set_fixed_column", { fields: this.selectedColumns, type: 1 })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.fields.forEach((column) => {
              column.fixed = this.selectedColumns.includes(column.id);
              this.$nextTick(() => {
                this.$refs.finance_table.doLayout();
              });
            });
            this.$message.success(data.msg);
          }
        });
    },
    handleAddChangeSave() {
      if (!this.addChangeData.bussin_content) {
        this.$message.error("商机内容不能为空");
        return;
      }
      if (!this.addChangeData.urgency) {
        this.$message.error("商机紧急程度不能为空");
        return;
      }
      this.$axios.post("/api/bussin_change", this.addChangeData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.clearChangeSuggest();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAddSuggestSave() {
      if (!this.suggestData.start_time) {
        this.$message.error("开始时间不能为空");
        return;
      }
      if (!this.suggestData.end_time) {
        this.$message.error("到期时间不能为空");
        return;
      }
      if (!this.suggestData.suggest_content) {
        this.$message.error("建议内容不能为空");
        return;
      }
      this.$axios.post("/api/finance/add_sug", this.suggestData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.clearChangeSuggest();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAddRenewSave() {
      if (!this.renewData.order_id) {
        this.$message.error("订单不能为空");
        return;
      }
      if (!this.renewData.start_time) {
        this.$message.error("服务开始时间不能为空");
        return;
      }
      if (!this.renewData.end_time) {
        this.$message.error("服务到期时间不能为空");
        return;
      }
      this.$axios
        .put("/api/finance/renews_add/" + this.renewData.id, this.renewData)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.clearChangeSuggest();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleAddBank() {
      if (!this.addBank.bank) {
        this.$message.error("开户银行不能为空");
        return;
      }
      if (!this.addBank.accnumber) {
        this.$message.error("开户行账户不能为空");
        return;
      }
      if (!this.addBank.bank_type) {
        this.$message.error("账户类型不能为空");
        return;
      }
      this.$axios.post("/api/finance/add_bank", this.addBank).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.fiscalData.banks.push(data.data);
          this.addBank.bank = "";
          this.addBank.accnumber = "";
          this.addBank.bank_type = "";
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getRenewOpeates(companyId) {
      this.$axios.get("/api/finance/renews_records/" + companyId).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.renewRecords = data.data;
        }
      });
    },
    handleContinueOpen(index, row) {
      this.clearChangeData();
      this.addChangeData.company_id = row.id;
      this.suggestData.company_id = row.id;
      this.renewData.company_id = row.id;
      this.companyName = row.company_name;
      this.getRenewOpeates(row.id);
      if (!row.fin_table) {
        this.$axios.get("/api/finance/fin_table/" + row.id).then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.suggestData.id = data.data.fin_table.id;
            this.renewData.id = data.data.fin_table.id;
            this.finances[index].fin_table = data.data.fin_table;
          }
        });
      } else {
        this.suggestData.id = row.fin_table.id;
        this.renewData.id = row.fin_table.id;
      }
      this.continueDrawer = true;
    },
    handleChatOpen(chat, companyName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatCompany = companyName;
        });
      }
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleEditBeforeClose(done) {
      this.clearEditDatas();
      done();
    },
    handleChatBeforeClose(done) {
      this.clearChatsData();
      done();
    },
    handleGetSearchData() {
      this.activeOpen = "";
      this.pageOption.currentPage = 1;
      this.getFinanceData();
    },
    handleClearSearchData() {
      this.activeOpen = "";
      this.clearSearchDatas();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getFinanceData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getFinanceData();
    },
    handleItemCurrentChange(val) {
      this.itemPage.currentPage = val;
      this.getItemsData(this.fiscalData.cid);
    },
    handleCompanyChange() {
      this.pageOption.currentPage = 1;
      this.getFinanceData();
    },
    handleBindUser() {
      if (!this.fiscalData.uid) {
        this.$message.error("请填写要绑定客户的id");
        return;
      }
      this.$axios
        .post("/api/finance/user_id/" + this.fiscalData.cid + "/" + this.fiscalData.uid)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.fiscalData.uid = data.data.user.id;
            this.fiscalData.uname = data.data.user.name;
            this.fiscalData.uphone = data.data.user.phone;
            this.fiscalData.uedit = true;
            this.finances[this.fiscalData.index].user = data.data.user;
          }
        });
    },
    getEditDataByCompany(index, cid) {
      this.$axios.get("/api/finance/fin_table/" + cid).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.upData.fid = data.data.fin_table.id;
          this.upData.start_time = data.data.fin_table.start_time;
          this.upData.end_time = data.data.fin_table.end_time;
          this.upData.legal_name = data.data.fin_table.legal_name;
          this.upData.legal_phone = data.data.fin_table.legal_phone;
          this.upData.legal_id_number = data.data.fin_table.legal_id_number;
          this.upData.tax_scale = data.data.fin_table.tax_scale;
          this.upData.area_park = data.data.fin_table.area_park
            ? data.data.fin_table.area_park
            : [];
          this.upData.tax_bureau = data.data.fin_table.tax_bureau
            ? data.data.fin_table.tax_bureau
            : [];
          this.upData.market_bureau = data.data.fin_table.market_bureau
            ? data.data.fin_table.market_bureau
            : [];
          this.upData.apply_type = data.data.fin_table.apply_type
            ? data.data.fin_table.apply_type
            : [];
          this.upData.debit_type = data.data.fin_table.debit_type
            ? data.data.fin_table.debit_type
            : [];
          this.upData.tax_password = data.data.fin_table.tax_password;
          this.upData.is_ukey = data.data.fin_table.is_ukey;
          this.upData.is_invoice_bill = data.data.fin_table.is_invoice_bill;
          this.upData.open_account = data.data.fin_table.open_account;
          // this.upData.invoice_company = data.data.fin_table.invoice_company;
          this.upData.order_combo = data.data.fin_table.order_combo;
          this.upData.order_item = this.getItemIds(data.data.fin_table.item_types);
          this.upData.license_auth = data.data.fin_table.license_auth;
          this.upData.finance_buut_join = data.data.fin_table.finance_buut_join;
          this.upData.social_security = data.data.fin_table.social_security;
          this.upData.accumula_fund = data.data.fin_table.accumula_fund;
          this.upData.triple_agreement = data.data.fin_table.triple_agreement;
          this.upData.back_bill_card = data.data.fin_table.back_bill_card;
          this.upData.manage_forms = data.data.fin_table.manage_forms;
          this.upData.server_status = data.data.fin_table.server_status;
          this.upData.invoice_seal = data.data.fin_table.invoice_seal;
          this.upData.other_remark = data.data.fin_table.other_remark;
          this.upData.is_zero_declare = data.data.fin_table.is_zero_declare;
          this.finances[index].fin_table = data.data.fin_table;
          this.getFinanceRecords(data.data.fin_table.id, data.data.id);
        }
      });
    },
    handleAddServer(index, row) {
      this.addServerDrawer = true;
      this.addServer.index = index;
      this.addServer.cid = row.id;
    },
    handleEditServer(index, row) {
      this.editServerDrawer = true;
      this.$nextTick(() => {
        this.companyName = row.company_name;
        this.editData = row;
      });

      // this.addServer.index = index
      // this.addServer.cid = row.id
    },
    handleAddServerData() {
      // if (!this.addServer.leader_id) {
      //   this.$message.error('请选择财税负责人')
      //   return
      // }
      // if (!this.addServer.acc_id) {
      //   this.$message.error('请选择理票会计')
      //   return
      // }
      // if (!this.addServer.advisory_id) {
      //   this.$message.error('请选择记账报税会计')
      //   return
      // }
      // if (!this.addServer.ass_id) {
      //   this.$message.error('请选择客服会计')
      //   return
      // }
      // if (!this.addServer.invoice_id) {
      //   this.$message.error('请选择开票会计')
      //   return
      // }
      // if (!this.addServer.server_time.length) {
      //   this.$message.error('请选择服务时间')
      //   return
      // }
      // if (!this.addServer.take_money_rule) {
      //   this.$message.error('请输入财务收费标准')
      //   return
      // }
      // if (!this.addServer.tax_type) {
      //   this.$message.error('请选择企业税种')
      //   return
      // }
      // if (!this.addServer.other_server.length) {
      //   this.$message.error('请选择服务内容')
      //   return
      // }
      if (this.addServer.take_money_rule) {
        var reg = /^-?\d{1,8}(?:\.\d{1,2})?$/; // 小数点左边最高4位，小数点右边最多4位
        if (!reg.test(this.addServer.take_money_rule)) {
          this.$message.warning("请输入正确的数字,小数点后可1到2位");
          return false;
        }
      }

      if (this.addServer.other_server.length > 0) {
        for (var i = 0; i < this.addServer.other_server.length; i++) {
          if (!this.addServer.take_money_rule_real[this.addServer.other_server[i]]) {
            return this.$message.warning("增值服务实际价格必须填写!");
          }
        }
        try {
          this.addServer.take_money_rule_real.map((item) => {
            if (item) {
              var reg = /^-?\d{1,8}(?:\.\d{1,2})?$/; // 小数点左边最高4位，小数点右边最多4位
              if (!reg.test(item)) {
                this.$message.warning("请在增值服务中输入正确的数字,小数点后可1到2位");
                throw new Error();
              }
            }
          });
        } catch (err) {
          return false;
        }
      }

      if (this.addServer.include_gifts) {
        if (this.addServer.gifts_length) {
          var numReg = /^[0-9]*$/;
          var numRe = new RegExp(numReg);
          if (!numRe.test(this.addServer.gifts_length)) {
            return this.$message.warning("赠送时长请输入数字！");
          }
        } else {
          return this.$message.warning("赠送时长没有填写！");
        }
      }

      this.$axios.post("/api/finance/add_server", this.addServer).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.finances[this.addServer.index].com_fiscal_tax = data.data.fiscal_tax;
          this.clearAddServerData();
          this.addServerDrawer = false;
          this.getFinanceData();
        }
      });
    },
    handleEditFinance(index, row) {
      this.accountingReportFile = [];
      this.businessLicenseFile = [];
      this.businessCopyFile = [];
      this.bankOpenFile = [];
      this.addRelated.company_id = row.company_id;
      this.addRelated.pass_and_password = row.pass_and_password;
      this.addRelated.registration_password = row.registration_password;
      this.addRelated.electronic_password = row.electronic_password;
      this.addRelated.wage_information = row.wage_information;
      this.upData.index = index;
      this.upData.company_id = row.id;
      this.upData.company_name = row.company_name;
      this.upData.date_of_est = row.date_of_est;
      this.upData.address_area = row.address_area;
      this.upData.address_park = row.address_park;
      if (!row.fin_table) {
        this.getEditDataByCompany(index, row.id);
      } else {
        this.upData.fid = row.fin_table.id;
        this.upData.start_time = row.fin_table.start_time;
        this.upData.end_time = row.fin_table.end_time;
        this.upData.legal_name = row.fin_table.legal_name;
        this.upData.legal_phone = row.fin_table.legal_phone;
        this.upData.legal_id_number = row.fin_table.legal_id_number;
        this.upData.tax_scale = row.fin_table.tax_scale;
        this.upData.check_tax_cate = this.getTaxCateIds(
          row.fin_table.check_tax_cate_name
        );
        this.upData.area_park = row.fin_table.area_park ? row.fin_table.area_park : [];
        this.upData.tax_bureau = row.fin_table.tax_bureau ? row.fin_table.tax_bureau : [];
        this.upData.market_bureau = row.fin_table.market_bureau
          ? row.fin_table.market_bureau
          : [];
        this.upData.tax_password = row.fin_table.tax_password;
        this.upData.is_ukey = row.fin_table.is_ukey;
        this.upData.is_invoice_bill = row.fin_table.is_invoice_bill;
        this.upData.open_account = row.fin_table.open_account;
        // this.upData.invoice_company = row.fin_table.invoice_company;
        this.upData.order_combo = row.fin_table.order_combo;
        this.upData.order_item = this.getItemIds(row.fin_table.item_types);
        this.upData.license_auth = row.fin_table.license_auth;
        this.upData.finance_buut_join = row.fin_table.finance_buut_join;
        this.upData.social_security = row.fin_table.social_security;
        this.upData.accumula_fund = row.fin_table.accumula_fund;
        this.upData.triple_agreement = row.fin_table.triple_agreement;
        this.upData.back_bill_card = row.fin_table.back_bill_card;
        this.upData.manage_forms = row.fin_table.manage_forms;
        this.upData.server_status = row.fin_table.server_status;
        this.upData.invoice_seal = row.fin_table.invoice_seal;
        this.upData.invoice_roughly =
          row.fin_table.fin_roughly.length > 0
            ? row.fin_table.fin_roughly[0].invoice_roughly
            : "";
        this.upData.roughly_arr =
          row.fin_table.fin_roughly.length > 0 ? row.fin_table.fin_roughly : [];
        this.upData.other_remark = row.fin_table.other_remark;
        this.upData.idcard_img = row.fin_table.idcard_img;
        this.upData.tax_over_name = row.fin_table.tax_over_name
          ? row.fin_table.tax_over_name
          : "";
        this.upData.tax_over_at = row.fin_table.tax_over_at
          ? row.fin_table.tax_over_at
          : "";
        this.upData.apply_type = row.fin_table.apply_type ? row.fin_table.apply_type : [];
        this.upData.debit_type = row.fin_table.debit_type ? row.fin_table.debit_type : [];
        this.fiscalData.start_time = row.fin_table.start_time
          ? row.fin_table.start_time
          : "";
        this.fiscalData.end_time = row.fin_table.end_time ? row.fin_table.end_time : "";
        this.upData.software_account = row.fin_table.software_account
          ? row.fin_table.software_account
          : "";
        this.upData.software_pass = row.fin_table.software_pass
          ? row.fin_table.software_pass
          : "";
        this.upData.advisory_account = row.fin_table.advisory_account
          ? row.fin_table.advisory_account
          : "";
        this.upData.advisory_pass = row.fin_table.advisory_pass
          ? row.fin_table.advisory_pass
          : "";
        this.upData.back_card_bank = row.fin_table.back_card_bank
          ? row.fin_table.back_card_bank
          : "";
        this.upData.back_card_number = row.fin_table.back_card_number
          ? row.fin_table.back_card_number
          : "";
        this.upData.back_card_pass = row.fin_table.back_card_pass
          ? row.fin_table.back_card_pass
          : "";
        this.upData.collect_type = row.fin_table.collect_type
          ? row.fin_table.collect_type
          : "";
        this.upData.is_trust = row.fin_table.is_trust;
        this.upData.is_buy_tax = row.fin_table.is_buy_tax;
        this.upData.is_tax_ctrl_typetrust = row.fin_table.tax_ctrl_type;
        this.upData.filing_place = row.fin_table.filing_place;
        this.upData.net_finance_person = row.fin_table.net_finance_person;
        this.upData.is_zero_declare = row.fin_table.is_zero_declare;
        this.getFinanceRecords(row.fin_table.id, row.id);
      }
      if (row.tax_payment) {
        this.upData.added_set = row.tax_payment.added_set;
        this.upData.addtional_set = row.tax_payment.addtional_set;
        this.upData.person_set = row.tax_payment.person_set;
        this.upData.bussin_tax_set = row.tax_payment.bussin_tax_set;
        this.upData.company_set = row.tax_payment.company_set;
        this.upData.stamp_set = row.tax_payment.stamp_set;
        this.upData.house_set = row.tax_payment.house_set;
        this.upData.finance_set = row.tax_payment.finance_set;
      }
      if (row.staffs.length) {
        this.upData.staffs = row.staffs;
      }
      if (row.user) {
        this.fiscalData.uid = row.user.id;
        this.fiscalData.uname = row.user.name;
        this.fiscalData.uphone = row.user.phone;
        this.fiscalData.regtime = row.user.regtime;
        this.fiscalData.uedit = true;
      }
      this.fiscalData.index = index;
      this.fiscalData.cid = row.id;
      this.fiscalData.cname = row.company_name;
      this.fiscalData.legaler = row.legaler;
      this.fiscalData.legaler_contact = row.legaler_contact;
      this.fiscalData.taxNumber = row.taxNumber;
      this.fiscalData.operate_address = row.operate_address;
      this.fiscalData.saler_id = row.saler_id;
      this.fiscalData.saler_name = row.salers ? row.salers.username : "";
      this.fiscalData.invoice_payee = row.invoice_payee;
      this.fiscalData.invoice_reviewer = row.invoice_reviewer;
      this.fiscalData.invoice_drawer = row.invoice_drawer;
      this.fiscalData.invoice_common = row.invoice_common;
      this.fiscalData.invoice_ecommon = row.invoice_ecommon;
      this.fiscalData.invoice_special = row.invoice_special;
      this.fiscalData.invoice_especial = row.invoice_especial;
      this.fiscalData.invoice_drawer = row.invoice_drawer;
      this.fiscalData.invoice_common_rate = row.invoice_common_rate;
      this.fiscalData.invoice_ecommon_rate = row.invoice_ecommon_rate;
      this.fiscalData.invoice_special_rate = row.invoice_special_rate;
      this.fiscalData.invoice_especial_rate = row.invoice_especial_rate;
      this.fiscalData.cre_code = row.cre_code;
      this.fiscalData.trade = row.trade;
      this.fiscalData.reg_cap = row.reg_cap;
      this.fiscalData.company_types = row.company_types;
      this.fiscalData.fromTime = row.fromTime;
      this.fiscalData.toTime = row.toTime;
      this.fiscalData.bus_scope = row.bus_scope;
      this.fiscalData.isMicroEnt = row.isMicroEnt;
      this.addBank.cid = row.id;
      if (row.com_fiscal_tax) {
        this.fiscalData.leader_id = row.com_fiscal_tax.leader_id
          ? row.com_fiscal_tax.leader_id
          : null;
        this.fiscalData.ass_id = row.com_fiscal_tax.ass_id
          ? row.com_fiscal_tax.ass_id
          : null;
        this.fiscalData.acc_id = row.com_fiscal_tax.acc_id
          ? row.com_fiscal_tax.acc_id
          : null;
        this.fiscalData.advisory_id = row.com_fiscal_tax.advisory_id
          ? row.com_fiscal_tax.advisory_id
          : null;
        this.fiscalData.invoice_id = row.com_fiscal_tax.invoice_id
          ? row.com_fiscal_tax.invoice_id
          : null;
        this.fiscalData.service_advisor_id = row.com_fiscal_tax.service_advisor_id
          ? row.com_fiscal_tax.service_advisor_id
          : null;
        this.fiscalData.general_accounting_id = row.com_fiscal_tax.general_accounting_id
          ? row.com_fiscal_tax.general_accounting_id
          : null;
        this.fiscalData.leader_name = row.com_fiscal_tax.leader
          ? row.com_fiscal_tax.leader.username
          : "";
        this.fiscalData.acc_name = row.com_fiscal_tax.acc
          ? row.com_fiscal_tax.acc.username
          : "";
        this.fiscalData.ass_name = row.com_fiscal_tax.ass
          ? row.com_fiscal_tax.ass.username
          : "";
        this.fiscalData.advisory_name = row.com_fiscal_tax.advisory
          ? row.com_fiscal_tax.advisory.username
          : "";
        this.fiscalData.invoice_name = row.com_fiscal_tax.invoice
          ? row.com_fiscal_tax.invoice.username
          : "";
        this.fiscalData.software_types = row.com_fiscal_tax.software_types
          ? row.com_fiscal_tax.software_types
          : null;
        this.fiscalData.report = row.com_fiscal_tax.report
          ? row.com_fiscal_tax.report
          : null;
      }
      this.fiscalData.services = this.getServiceNames(row.services);
      this.fiscalData.order_nums = row.tyc_orders;
      this.fiscalData.banks = row.banks ? row.banks : [];
      this.getItemsData(row.id);
      this.editDrawer = true;
    },
    handleConBeforeClose() {
      this.companyName = "";
      this.clearChangeSuggest();
    },
    clearEditDatas() {
      this.upData.company_id = "";
      this.upData.company_name = "";
      this.upData.start_time = "";
      this.upData.end_time = "";
      this.upData.legal_name = "";
      this.upData.legal_phone = "";
      this.upData.legal_id_number = "";
      this.upData.tax_scale = "";
      this.upData.check_tax_cate = [];
      this.upData.area_park = [];
      this.upData.tax_password = "";
      this.upData.is_ukey = "";
      this.upData.is_invoice_bill = "";
      this.upData.open_account = "";
      // this.upData.invoice_company = "";
      this.upData.order_combo = "";
      this.upData.order_item = [];
      this.upData.license_auth = "";
      this.upData.finance_buut_join = "";
      this.upData.social_security = "";
      this.upData.accumula_fund = "";
      this.upData.triple_agreement = "";
      this.upData.back_bill_card = "";
      this.upData.manage_forms = "";
      this.upData.server_status = "";
      this.upData.other_remark = "";
      this.upData.invoice_seal = "";
      this.upData.invoice_roughly = "";
      this.upData.roughly_arr = [];
      this.upData.index = null;
      this.upData.fid = null;
      this.upData.added_set = "";
      this.upData.addtional_set = "";
      this.upData.person_set = "";
      this.upData.bussin_tax_set = "";
      this.upData.company_set = "";
      this.upData.stamp_set = "";
      this.upData.house_set = "";
      this.upData.finance_set = "";
      this.upData.software_account = "";
      this.upData.software_pass = "";
      this.upData.advisory_account = "";
      this.upData.advisory_pass = "";
      this.upData.date_of_est = "";
      this.upData.address_area = "";
      this.upData.address_park = "";
      this.upData.tax_bureau = [];
      this.upData.market_bureau = [];
      this.upData.staffs = [];
      this.upData.apply_type = [];
      this.upData.debit_type = [];
      this.upData.idcard_img = [];
      this.upData.tax_over_name = "";
      this.upData.tax_over_at = "";
      this.upData.is_trust = null;
      this.upData.is_buy_tax = "";
      this.upData.tax_ctrl_type = "";
      this.upData.filing_place = "";
      this.upData.back_card_bank = "";
      this.upData.back_card_number = "";
      this.upData.back_card_pass = "";
      this.upData.collect_type = "";
      this.upData.net_finance_person = null;
      this.upData.is_zero_declare = 0;
      this.fiscalData.cid = null;
      this.fiscalData.banks = [];
      this.fiscalData.order_nums = [];
      this.fiscalData.services = [];
      this.fiscalData.leader_id = null;
      this.fiscalData.acc_id = null;
      this.fiscalData.ass_id = null;
      this.fiscalData.advisory_id = null;
      this.fiscalData.invoice_id = null;
      this.fiscalData.service_advisor_id = null;
      this.fiscalData.general_accounting_id = null;
      this.fiscalData.saler_id = null;
      this.fiscalData.software_types = null;
      this.fiscalData.report = null;
      this.fiscalData.saler_name = "";
      this.fiscalData.leader_name = "";
      this.fiscalData.ass_name = "";
      this.fiscalData.acc_name = "";
      this.fiscalData.advisory_name = "";
      this.fiscalData.invoice_name = "";
      this.fiscalData.cname = "";
      this.fiscalData.legaler = "";
      this.fiscalData.legaler_contact = "";
      this.fiscalData.taxNumber = "";
      this.fiscalData.operate_address = "";
      this.fiscalData.invoice_payee = null;
      this.fiscalData.invoice_reviewer = null;
      this.fiscalData.invoice_drawer = null;
      this.fiscalData.uid = null;
      this.fiscalData.uname = "";
      this.fiscalData.uphone = "";
      this.fiscalData.regtime = "";
      this.fiscalData.uedit = false;
      this.fiscalData.index = null;
      this.fiscalData.invoice_common = null;
      this.fiscalData.invoice_ecommon = null;
      this.fiscalData.invoice_special = null;
      this.fiscalData.invoice_especial = null;
      this.fiscalData.invoice_common_rate = null;
      this.fiscalData.invoice_ecommon_rate = null;
      this.fiscalData.invoice_special_rate = null;
      this.fiscalData.invoice_especial_rate = null;
      this.fiscalData.cre_code = "";
      this.fiscalData.trade = "";
      this.fiscalData.reg_cap = "";
      this.fiscalData.company_types = "";
      this.fiscalData.fromTime = "";
      this.fiscalData.toTime = "";
      this.fiscalData.bus_scope = "";
      this.fiscalData.isMicroEnt = "";
      this.addBank.cid = null;
      this.addBank.bank = "";
      this.addBank.accnumber = "";
      this.addBank.bank_type = "";
      this.activeName = "first";
      this.companys = [];
    },
    clearSearchDatas() {
      this.searchArr.company_id = "";
      this.searchArr.start_time = null;
      this.searchArr.end_time = null;
      this.searchArr.start_time_null = false;
      this.searchArr.end_time_null = false;
      this.searchArr.finance_user = "";
      this.searchArr.saler_id = [];
      this.searchArr.service_advisor_id = "";
      this.searchArr.general_accounting_id = "";
      this.searchArr.leader_id = "";
      this.searchArr.acc_id = "";
      this.searchArr.ass_id = "";
      this.searchArr.advisory_id = "";
      this.searchArr.invoice_id = "";
      this.searchArr.area_park = [];
      this.searchArr.order_combo = "";
      this.searchArr.is_ukey = "";
      this.searchArr.is_invoice_bill = "";
      this.searchArr.license_auth = "";
      this.searchArr.triple_agreement = "";
      this.searchArr.social_security = "";
      this.searchArr.accumula_fund = "";
      this.searchArr.manage_forms = "";
      this.searchArr.server_status = "";
      // this.searchArr.invoice_company = "";
      this.searchArr.open_account = "";
      this.searchArr.tax_scale = "";
      this.searchArr.is_bind = "";
      this.searchArr.is_subscribe = "";
      this.searchArr.server_end = "";
      this.searchArr.wx_work_bind = "";
      this.searchArr.archives = "";
      this.searchArr.provinces_code = "";
      this.searchArr.city_code = "";
      this.searchArr.area_code = "";
      this.searchArr.login_way = "";
      this.searchArr.taxNumber = "";
      this.searchArr.my_electronic_password = "";
      this.searchArr.login_identity = "";
      this.searchArr.login_account = "";
      this.searchArr.login_password = "";
      this.searchArr.ca_password = "";
      this.searchArr.natural_identity = "";
      this.searchArr.natural_password = "";
      this.searchArr.digital_certificate_password = "";
      this.searchArr.digital_identity = "";
      this.searchArr.digital_account = "";
      this.searchArr.digital_password = "";
      this.searchArr.income_tax_way = "";
      this.searchArr.income_tax_password = "";
      this.searchArr.income_real_account = "";
      this.searchArr.income_real_password = "";
      this.searchArr.social_account = "";
      this.searchArr.social_password = "";
      this.searchArr.satisfy = "";
      this.searchArr.chat_keyword = [];
      this.getFinanceData();
    },
    clearChatsData() {
      this.chatId = "";
      this.chatDrawer = false;
      this.companyId = null;
      this.chatCompany = "";
    },
    clearChangeData() {
      this.addChangeData.company_id = "";
      this.addChangeData.bussin_content = [];
      this.addChangeData.uid = "";
      this.addChangeData.urgency = 1;
      this.addChangeData.remark = "";
    },
    clearSuggestAdd() {
      this.suggestData.company_id = "";
      this.suggestData.start_time = "";
      this.suggestData.end_time = "";
      this.suggestData.current_combo = "";
      this.suggestData.current_item = [];
      this.suggestData.suggest_content = "";
      this.suggestData.id = null;
    },
    clearRenewData() {
      this.renewData.id = null;
      this.renewData.company_id = "";
      this.renewData.order_id = "";
      this.renewData.start_time = "";
      this.renewData.end_time = "";
    },
    clearChangeSuggest() {
      this.clearChangeData();
      this.clearSuggestAdd();
      this.clearRenewData();
      this.activeConName = "first";
      this.continueDrawer = false;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchOrders(query);
        }, 200);
      } else {
        this.orderNums = [];
      }
    },
    searchOrders(query) {
      this.$axios.get("/api/admin/searchOrders?num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orderNums = data.data.orderNum;
        }
      });
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleSaveRoughly() {
      if (!this.addRoughly) {
        this.$message.error("请填写发票号段");
        return;
      }
      this.$axios
        .post("/api/finance/set_roughly/" + this.upData.fid, {
          roughly: this.addRoughly,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.addRoughly = "";
            this.addVisible = false;
            this.upData.invoice_roughly = data.data.roughly.invoice_roughly;
            this.upData.roughly_arr.unshift(data.data.roughly);
            this.finances[this.upData.index].fin_table.fin_roughly.unshift(
              data.data.roughly
            );
            this.records.unshift(data.data.record);
          }
        });
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.tyc_orders.length > 0) {
          for (var i = 0; i < row.tyc_orders.length; i++) {
            if (
              row.tyc_orders[i].customer_phone &&
              this.callPhone1.indexOf(row.tyc_orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.tyc_orders[i].customer_phone);
            }
            if (
              row.tyc_orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.tyc_orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.tyc_orders[i].corporate_phone);
            }
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleOrderInfo(orderId) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
      }, 100);
    },
    handleSetTaxDetail() {
      if (!this.upData.added_set) {
        this.$message.error("请选择增值税周期");
        return;
      }
      if (!this.upData.addtional_set) {
        this.$message.error("请选择附加税周期");
        return;
      }
      if (!this.upData.person_set) {
        this.$message.error("请选择个人所得税周期");
        return;
      }
      if (!this.upData.bussin_tax_set) {
        this.$message.error("请选择生产经营个税周期");
        return;
      }
      if (!this.upData.company_set) {
        this.$message.error("请选择企业所得税周期");
        return;
      }
      if (!this.upData.stamp_set) {
        this.$message.error("请选择印花税周期");
        return;
      }
      if (!this.upData.house_set) {
        this.$message.error("请选择房产税周期");
        return;
      }
      if (!this.upData.finance_set) {
        this.$message.error("请选择财务报表周期");
        return;
      }
      this.$axios
        .post("/api/finance/set_tax", {
          cid: this.upData.company_id,
          added_set: this.upData.added_set,
          addtional_set: this.upData.addtional_set,
          person_set: this.upData.person_set,
          bussin_tax_set: this.upData.bussin_tax_set,
          company_set: this.upData.company_set,
          stamp_set: this.upData.stamp_set,
          house_set: this.upData.house_set,
          finance_set: this.upData.finance_set,
        })
        .then((res) => {
          const { data } = res;
          this.$message.success(data.msg);
        });
    },
    handleLicensePreview(file) {},
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList;
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList.length < 2) {
            that.licenseList.push(fileObj);
          } else {
            that.$message.error("最多可以上传2张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload() {
      if (this.licenseList.length === 0) {
        this.$message.error("请上传法人身份证图片");
        return;
      }
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      this.$axios
        .post("/api/finance/idcard_upload/" + this.upData.fid, this.formData)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.upData.idcard_img = data.data;
            this.$message.success(data.msg);
            this.formData = null;
            this.licenseList = [];
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getCheckTaxCateName(checkTaxCate) {
      if (checkTaxCate.length > 0) {
        let strings = "";
        for (let key in this.tax_cates) {
          if (checkTaxCate.indexOf(this.tax_cates[key].id) !== -1) {
            strings += this.tax_cates[key].name + ",";
          }
        }
        return strings.slice(0, strings.length - 1);
      }
    },
    getStaffIsServer(arr) {
      let on = 0;
      let leave = 0;
      if (arr.length > 0) {
        for (let key in arr) {
          if (arr[key].is_inservice === 1) {
            on += 1;
          } else {
            leave += 1;
          }
        }
      }
      return "在职员工" + on + "位，离职员工" + leave + "位";
    },
    fhandleCompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    clearAddServerData() {
      this.addServerDrawer = false;
      this.addServer.cid = null;
      this.addServer.leader_id = null;
      this.addServer.acc_id = null;
      this.addServer.ass_id = null;
      this.addServer.advisory_id = null;
      this.addServer.invoice_id = null;
      this.addServer.service_advisor_id = null;
      this.addServer.general_accounting_id = '';
      this.addServer.share_id = null;
      this.addServer.proxy_software = "";
      this.addServer.include_gifts = false;
      this.addServer.gifts_length = "";
      this.addServer.index = null;
      this.addServer.server_time = [];
      this.addServer.tax_type = "";
      this.addServer.other_server = [];
      this.addServer.is_zero = "";
      this.addServer.begin_time = "";
      this.addServer.take_money_rule = "";
      this.addServer.take_money_rule_real = [];
    },
    handleAddServerBeforeClose(done) {
      this.addServerDrawer = false;
      this.addServer.cid = null;
      this.addServer.leader_id = null;
      this.addServer.acc_id = null;
      this.addServer.ass_id = null;
      this.addServer.advisory_id = null;
      this.addServer.invoice_id = null;
      this.addServer.service_advisor_id = null;
      this.addServer.general_accounting_id = '';
      this.addServer.share_id = null;
      this.addServer.proxy_software = "";
      this.addServer.include_gifts = false;
      this.addServer.gifts_length = "";
      this.addServer.index = null;
      this.addServer.server_time = [];
      this.addServer.tax_type = "";
      this.addServer.other_server = [];
      this.addServer.take_money_rule = "";
      this.addServer.take_money_rule_real = [];
      this.addServer.is_zero = "";
      this.addServer.begin_time = "";
      done();
    },
    handleEditServerBeforeClose(done) {
      // this.addServerDrawer = false
      // this.addServer.cid = null
      // this.addServer.leader_id = null
      // this.addServer.acc_id = null
      // this.addServer.ass_id = null
      // this.addServer.advisory_id = null
      // this.addServer.invoice_id = null
      // this.addServer.index = null
      // this.addServer.server_time = []
      // this.addServer.tax_type = ''
      // this.addServer.other_server = []
      // this.addServer.take_money_rule = ''
      this.editData = null;
      done();
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    serviceEventState(state) {
      if (state === true) {
        this.serviceEvent = true;
      } else {
        this.serviceEvent = false;
      }
    },
    serviceThingsState(state) {
      if (state === true) {
        this.serviceThings = true;
      } else {
        this.serviceThings = false;
      }
    },
    serviceAccountState(state) {
      if (state === true) {
        this.serviceAccount = true;
      } else {
        this.serviceAccount = false;
      }
    },
    showExample() {
      this.loadExamplePicture();
      this.showExampleDialog = true;
    },
    loadExamplePicture() {
      this.$axios
        .get("api/finance/get_example")
        .then(({ data }) => {
          if (data.code === 200) {
            this.example_url = data.data.url;
          }
        })
        .catch();
    },
    closeShowExampleDialog() {
      this.example_url = "";
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    tableColumn(prop) {
      const widthMap = new Map([
        ["start_time", 130],
        ["end_time", 130],
        ["finance_user", 130],
        ["triple_agreement", 130],
        ["advisory", 130],
        ["is_auth", 130],
        ["subscribe", 130],
        ["legal_name", 110],
        ["legal_id_number", 110],
        ["leader", 110],
        ["is_ukey", 110],
      ]);
      return widthMap.get(prop) || "";
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
}
  },
  mounted() {
    this.getFinanceData();
    document.addEventListener("click", this.handleClickCollapseOutSide);
    // this.getFinanceSettingParams()
  },
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}

#value-add-table td {
  font-size: medium;
  line-height: 0.5rem;
}

.options-first {
  margin-top: 0.05rem;
}

.options-second {
  margin-top: 0.05rem;
  margin-left: 0.4rem;
}

.finance_table_div {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 126px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 15px;
    }
  }
}

a {
  background: transparent;
  color: #108ee9;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  transition: color 0.3s ease;
}

.el-col-3 {
  margin-right: 10px;
}

.text {
  font-size: 14px;
}

.items {
  margin-bottom: 18px;
}

.m-tabs-content >>> .el-form-item__label {
  width: 190px !important;
}

.m-tabs-content >>> .el-form-item__content {
  margin-left: 200px !important;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4c87fc;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4c87fc;
}

.el-select {
  width: 100%;
}

.finance_table_div >>> .el-table__header th {
  color: #333333;
  background-color: #ecf4ff;
}

.finance_table_div .count_style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}

.m-tabs-content .m-label {
  line-height: 0.64rem;
}

.m-tabs-content .el-row {
  margin-bottom: 0.4rem;
}

.el-date-editor {
  width: 100%;
}

.top-line {
  color: #409eff;
  font-weight: bold;
  margin: 0 0 0 0;
}

.messages-list {
  min-height: calc(100vh - 210px);
  height: 6rem;
  overflow-y: auto;
}

.messages-list .messages-con {
  padding: 0.4rem;
}

.messages-list .messages-con .message {
  padding: 0.2rem;
}

.messages-list .messages-con .image_con {
  padding: 0.2rem;
}

.messages-list .infinite-item-content {
  display: inline-block;
  margin-top: 0.2rem;
  padding: 0 0.36rem 0 0.36rem;
  line-height: 0.9rem;
  background-color: #eef0f5;
}

.messages-list .popper__arrow {
  position: absolute;
  top: 0.04rem;
  left: 0.36rem;
  display: block;
  margin-right: 0.06rem;
  border-color: transparent;
  border-style: solid;
  border-width: 0.18rem;
  border-top-width: 0;
  border-bottom-color: #eef0f5;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}

.top_hint {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #ecf4ff;
}

.top_hint span {
  color: #5787ff;
}

.icon-class {
  width: 16px;
  margin-bottom: 0.06rem;
  margin-right: 0.1rem;
}
.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409EFF;
}

.hide-style{
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance_register/FinanceTable.vue